import { g as greyScaleColors, p as primaryBlueColors, s as secondaryColors, a as alternativeColors, b as greyScaleColors$1, c as primaryBlueColors$1, d as secondaryColors$1, e as alternativeColors$1 } from './color.definition-8f4d584f.js';

/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
const t$1=window.ShadowRoot&&(void 0===window.ShadyCSS||window.ShadyCSS.nativeShadow)&&"adoptedStyleSheets"in Document.prototype&&"replace"in CSSStyleSheet.prototype,e$2=Symbol(),n$3=new WeakMap;class s$3{constructor(t,n,s){if(this._$cssResult$=!0,s!==e$2)throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");this.cssText=t,this.t=n;}get styleSheet(){let e=this.o;const s=this.t;if(t$1&&void 0===e){const t=void 0!==s&&1===s.length;t&&(e=n$3.get(s)),void 0===e&&((this.o=e=new CSSStyleSheet).replaceSync(this.cssText),t&&n$3.set(s,e));}return e}toString(){return this.cssText}}const o$3=t=>new s$3("string"==typeof t?t:t+"",void 0,e$2),r$2=(t,...n)=>{const o=1===t.length?t[0]:n.reduce(((e,n,s)=>e+(t=>{if(!0===t._$cssResult$)return t.cssText;if("number"==typeof t)return t;throw Error("Value passed to 'css' function must be a 'css' function result: "+t+". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.")})(n)+t[s+1]),t[0]);return new s$3(o,t,e$2)},i$1=(e,n)=>{t$1?e.adoptedStyleSheets=n.map((t=>t instanceof CSSStyleSheet?t:t.styleSheet)):n.forEach((t=>{const n=document.createElement("style"),s=window.litNonce;void 0!==s&&n.setAttribute("nonce",s),n.textContent=t.cssText,e.appendChild(n);}));},S$1=t$1?t=>t:t=>t instanceof CSSStyleSheet?(t=>{let e="";for(const n of t.cssRules)e+=n.cssText;return o$3(e)})(t):t;

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var s$2;const e$1=window.trustedTypes,r$1=e$1?e$1.emptyScript:"",h$1=window.reactiveElementPolyfillSupport,o$2={toAttribute(t,i){switch(i){case Boolean:t=t?r$1:null;break;case Object:case Array:t=null==t?t:JSON.stringify(t);}return t},fromAttribute(t,i){let s=t;switch(i){case Boolean:s=null!==t;break;case Number:s=null===t?null:Number(t);break;case Object:case Array:try{s=JSON.parse(t);}catch(t){s=null;}}return s}},n$2=(t,i)=>i!==t&&(i==i||t==t),l$2={attribute:!0,type:String,converter:o$2,reflect:!1,hasChanged:n$2};class a$1 extends HTMLElement{constructor(){super(),this._$Ei=new Map,this.isUpdatePending=!1,this.hasUpdated=!1,this._$El=null,this.u();}static addInitializer(t){var i;null!==(i=this.h)&&void 0!==i||(this.h=[]),this.h.push(t);}static get observedAttributes(){this.finalize();const t=[];return this.elementProperties.forEach(((i,s)=>{const e=this._$Ep(s,i);void 0!==e&&(this._$Ev.set(e,s),t.push(e));})),t}static createProperty(t,i=l$2){if(i.state&&(i.attribute=!1),this.finalize(),this.elementProperties.set(t,i),!i.noAccessor&&!this.prototype.hasOwnProperty(t)){const s="symbol"==typeof t?Symbol():"__"+t,e=this.getPropertyDescriptor(t,s,i);void 0!==e&&Object.defineProperty(this.prototype,t,e);}}static getPropertyDescriptor(t,i,s){return {get(){return this[i]},set(e){const r=this[t];this[i]=e,this.requestUpdate(t,r,s);},configurable:!0,enumerable:!0}}static getPropertyOptions(t){return this.elementProperties.get(t)||l$2}static finalize(){if(this.hasOwnProperty("finalized"))return !1;this.finalized=!0;const t=Object.getPrototypeOf(this);if(t.finalize(),this.elementProperties=new Map(t.elementProperties),this._$Ev=new Map,this.hasOwnProperty("properties")){const t=this.properties,i=[...Object.getOwnPropertyNames(t),...Object.getOwnPropertySymbols(t)];for(const s of i)this.createProperty(s,t[s]);}return this.elementStyles=this.finalizeStyles(this.styles),!0}static finalizeStyles(i){const s=[];if(Array.isArray(i)){const e=new Set(i.flat(1/0).reverse());for(const i of e)s.unshift(S$1(i));}else void 0!==i&&s.push(S$1(i));return s}static _$Ep(t,i){const s=i.attribute;return !1===s?void 0:"string"==typeof s?s:"string"==typeof t?t.toLowerCase():void 0}u(){var t;this._$E_=new Promise((t=>this.enableUpdating=t)),this._$AL=new Map,this._$Eg(),this.requestUpdate(),null===(t=this.constructor.h)||void 0===t||t.forEach((t=>t(this)));}addController(t){var i,s;(null!==(i=this._$ES)&&void 0!==i?i:this._$ES=[]).push(t),void 0!==this.renderRoot&&this.isConnected&&(null===(s=t.hostConnected)||void 0===s||s.call(t));}removeController(t){var i;null===(i=this._$ES)||void 0===i||i.splice(this._$ES.indexOf(t)>>>0,1);}_$Eg(){this.constructor.elementProperties.forEach(((t,i)=>{this.hasOwnProperty(i)&&(this._$Ei.set(i,this[i]),delete this[i]);}));}createRenderRoot(){var t;const s=null!==(t=this.shadowRoot)&&void 0!==t?t:this.attachShadow(this.constructor.shadowRootOptions);return i$1(s,this.constructor.elementStyles),s}connectedCallback(){var t;void 0===this.renderRoot&&(this.renderRoot=this.createRenderRoot()),this.enableUpdating(!0),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostConnected)||void 0===i?void 0:i.call(t)}));}enableUpdating(t){}disconnectedCallback(){var t;null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostDisconnected)||void 0===i?void 0:i.call(t)}));}attributeChangedCallback(t,i,s){this._$AK(t,s);}_$EO(t,i,s=l$2){var e,r;const h=this.constructor._$Ep(t,s);if(void 0!==h&&!0===s.reflect){const n=(null!==(r=null===(e=s.converter)||void 0===e?void 0:e.toAttribute)&&void 0!==r?r:o$2.toAttribute)(i,s.type);this._$El=t,null==n?this.removeAttribute(h):this.setAttribute(h,n),this._$El=null;}}_$AK(t,i){var s,e;const r=this.constructor,h=r._$Ev.get(t);if(void 0!==h&&this._$El!==h){const t=r.getPropertyOptions(h),n=t.converter,l=null!==(e=null!==(s=null==n?void 0:n.fromAttribute)&&void 0!==s?s:"function"==typeof n?n:null)&&void 0!==e?e:o$2.fromAttribute;this._$El=h,this[h]=l(i,t.type),this._$El=null;}}requestUpdate(t,i,s){let e=!0;void 0!==t&&(((s=s||this.constructor.getPropertyOptions(t)).hasChanged||n$2)(this[t],i)?(this._$AL.has(t)||this._$AL.set(t,i),!0===s.reflect&&this._$El!==t&&(void 0===this._$EC&&(this._$EC=new Map),this._$EC.set(t,s))):e=!1),!this.isUpdatePending&&e&&(this._$E_=this._$Ej());}async _$Ej(){this.isUpdatePending=!0;try{await this._$E_;}catch(t){Promise.reject(t);}const t=this.scheduleUpdate();return null!=t&&await t,!this.isUpdatePending}scheduleUpdate(){return this.performUpdate()}performUpdate(){var t;if(!this.isUpdatePending)return;this.hasUpdated,this._$Ei&&(this._$Ei.forEach(((t,i)=>this[i]=t)),this._$Ei=void 0);let i=!1;const s=this._$AL;try{i=this.shouldUpdate(s),i?(this.willUpdate(s),null===(t=this._$ES)||void 0===t||t.forEach((t=>{var i;return null===(i=t.hostUpdate)||void 0===i?void 0:i.call(t)})),this.update(s)):this._$Ek();}catch(t){throw i=!1,this._$Ek(),t}i&&this._$AE(s);}willUpdate(t){}_$AE(t){var i;null===(i=this._$ES)||void 0===i||i.forEach((t=>{var i;return null===(i=t.hostUpdated)||void 0===i?void 0:i.call(t)})),this.hasUpdated||(this.hasUpdated=!0,this.firstUpdated(t)),this.updated(t);}_$Ek(){this._$AL=new Map,this.isUpdatePending=!1;}get updateComplete(){return this.getUpdateComplete()}getUpdateComplete(){return this._$E_}shouldUpdate(t){return !0}update(t){void 0!==this._$EC&&(this._$EC.forEach(((t,i)=>this._$EO(i,this[i],t))),this._$EC=void 0),this._$Ek();}updated(t){}firstUpdated(t){}}a$1.finalized=!0,a$1.elementProperties=new Map,a$1.elementStyles=[],a$1.shadowRootOptions={mode:"open"},null==h$1||h$1({ReactiveElement:a$1}),(null!==(s$2=globalThis.reactiveElementVersions)&&void 0!==s$2?s$2:globalThis.reactiveElementVersions=[]).push("1.3.3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var t;const i=globalThis.trustedTypes,s$1=i?i.createPolicy("lit-html",{createHTML:t=>t}):void 0,e=`lit$${(Math.random()+"").slice(9)}$`,o$1="?"+e,n$1=`<${o$1}>`,l$1=document,h=(t="")=>l$1.createComment(t),r=t=>null===t||"object"!=typeof t&&"function"!=typeof t,d=Array.isArray,u=t=>{var i;return d(t)||"function"==typeof(null===(i=t)||void 0===i?void 0:i[Symbol.iterator])},c=/<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g,v=/-->/g,a=/>/g,f=/>|[ 	\n\r](?:([^\s"'>=/]+)([ 	\n\r]*=[ 	\n\r]*(?:[^ 	\n\r"'`<>=]|("|')|))|$)/g,_=/'/g,m=/"/g,g=/^(?:script|style|textarea|title)$/i,p=t=>(i,...s)=>({_$litType$:t,strings:i,values:s}),$=p(1),b=Symbol.for("lit-noChange"),w=Symbol.for("lit-nothing"),T=new WeakMap,x=(t,i,s)=>{var e,o;const n=null!==(e=null==s?void 0:s.renderBefore)&&void 0!==e?e:i;let l=n._$litPart$;if(void 0===l){const t=null!==(o=null==s?void 0:s.renderBefore)&&void 0!==o?o:null;n._$litPart$=l=new N(i.insertBefore(h(),t),t,void 0,null!=s?s:{});}return l._$AI(t),l},A=l$1.createTreeWalker(l$1,129,null,!1),C=(t,i)=>{const o=t.length-1,l=[];let h,r=2===i?"<svg>":"",d=c;for(let i=0;i<o;i++){const s=t[i];let o,u,p=-1,$=0;for(;$<s.length&&(d.lastIndex=$,u=d.exec(s),null!==u);)$=d.lastIndex,d===c?"!--"===u[1]?d=v:void 0!==u[1]?d=a:void 0!==u[2]?(g.test(u[2])&&(h=RegExp("</"+u[2],"g")),d=f):void 0!==u[3]&&(d=f):d===f?">"===u[0]?(d=null!=h?h:c,p=-1):void 0===u[1]?p=-2:(p=d.lastIndex-u[2].length,o=u[1],d=void 0===u[3]?f:'"'===u[3]?m:_):d===m||d===_?d=f:d===v||d===a?d=c:(d=f,h=void 0);const y=d===f&&t[i+1].startsWith("/>")?" ":"";r+=d===c?s+n$1:p>=0?(l.push(o),s.slice(0,p)+"$lit$"+s.slice(p)+e+y):s+e+(-2===p?(l.push(void 0),i):y);}const u=r+(t[o]||"<?>")+(2===i?"</svg>":"");if(!Array.isArray(t)||!t.hasOwnProperty("raw"))throw Error("invalid template strings array");return [void 0!==s$1?s$1.createHTML(u):u,l]};class E{constructor({strings:t,_$litType$:s},n){let l;this.parts=[];let r=0,d=0;const u=t.length-1,c=this.parts,[v,a]=C(t,s);if(this.el=E.createElement(v,n),A.currentNode=this.el.content,2===s){const t=this.el.content,i=t.firstChild;i.remove(),t.append(...i.childNodes);}for(;null!==(l=A.nextNode())&&c.length<u;){if(1===l.nodeType){if(l.hasAttributes()){const t=[];for(const i of l.getAttributeNames())if(i.endsWith("$lit$")||i.startsWith(e)){const s=a[d++];if(t.push(i),void 0!==s){const t=l.getAttribute(s.toLowerCase()+"$lit$").split(e),i=/([.?@])?(.*)/.exec(s);c.push({type:1,index:r,name:i[2],strings:t,ctor:"."===i[1]?M:"?"===i[1]?H:"@"===i[1]?I:S});}else c.push({type:6,index:r});}for(const i of t)l.removeAttribute(i);}if(g.test(l.tagName)){const t=l.textContent.split(e),s=t.length-1;if(s>0){l.textContent=i?i.emptyScript:"";for(let i=0;i<s;i++)l.append(t[i],h()),A.nextNode(),c.push({type:2,index:++r});l.append(t[s],h());}}}else if(8===l.nodeType)if(l.data===o$1)c.push({type:2,index:r});else {let t=-1;for(;-1!==(t=l.data.indexOf(e,t+1));)c.push({type:7,index:r}),t+=e.length-1;}r++;}}static createElement(t,i){const s=l$1.createElement("template");return s.innerHTML=t,s}}function P(t,i,s=t,e){var o,n,l,h;if(i===b)return i;let d=void 0!==e?null===(o=s._$Cl)||void 0===o?void 0:o[e]:s._$Cu;const u=r(i)?void 0:i._$litDirective$;return (null==d?void 0:d.constructor)!==u&&(null===(n=null==d?void 0:d._$AO)||void 0===n||n.call(d,!1),void 0===u?d=void 0:(d=new u(t),d._$AT(t,s,e)),void 0!==e?(null!==(l=(h=s)._$Cl)&&void 0!==l?l:h._$Cl=[])[e]=d:s._$Cu=d),void 0!==d&&(i=P(t,d._$AS(t,i.values),d,e)),i}class V{constructor(t,i){this.v=[],this._$AN=void 0,this._$AD=t,this._$AM=i;}get parentNode(){return this._$AM.parentNode}get _$AU(){return this._$AM._$AU}p(t){var i;const{el:{content:s},parts:e}=this._$AD,o=(null!==(i=null==t?void 0:t.creationScope)&&void 0!==i?i:l$1).importNode(s,!0);A.currentNode=o;let n=A.nextNode(),h=0,r=0,d=e[0];for(;void 0!==d;){if(h===d.index){let i;2===d.type?i=new N(n,n.nextSibling,this,t):1===d.type?i=new d.ctor(n,d.name,d.strings,this,t):6===d.type&&(i=new L(n,this,t)),this.v.push(i),d=e[++r];}h!==(null==d?void 0:d.index)&&(n=A.nextNode(),h++);}return o}m(t){let i=0;for(const s of this.v)void 0!==s&&(void 0!==s.strings?(s._$AI(t,s,i),i+=s.strings.length-2):s._$AI(t[i])),i++;}}class N{constructor(t,i,s,e){var o;this.type=2,this._$AH=w,this._$AN=void 0,this._$AA=t,this._$AB=i,this._$AM=s,this.options=e,this._$Cg=null===(o=null==e?void 0:e.isConnected)||void 0===o||o;}get _$AU(){var t,i;return null!==(i=null===(t=this._$AM)||void 0===t?void 0:t._$AU)&&void 0!==i?i:this._$Cg}get parentNode(){let t=this._$AA.parentNode;const i=this._$AM;return void 0!==i&&11===t.nodeType&&(t=i.parentNode),t}get startNode(){return this._$AA}get endNode(){return this._$AB}_$AI(t,i=this){t=P(this,t,i),r(t)?t===w||null==t||""===t?(this._$AH!==w&&this._$AR(),this._$AH=w):t!==this._$AH&&t!==b&&this.$(t):void 0!==t._$litType$?this.T(t):void 0!==t.nodeType?this.k(t):u(t)?this.S(t):this.$(t);}M(t,i=this._$AB){return this._$AA.parentNode.insertBefore(t,i)}k(t){this._$AH!==t&&(this._$AR(),this._$AH=this.M(t));}$(t){this._$AH!==w&&r(this._$AH)?this._$AA.nextSibling.data=t:this.k(l$1.createTextNode(t)),this._$AH=t;}T(t){var i;const{values:s,_$litType$:e}=t,o="number"==typeof e?this._$AC(t):(void 0===e.el&&(e.el=E.createElement(e.h,this.options)),e);if((null===(i=this._$AH)||void 0===i?void 0:i._$AD)===o)this._$AH.m(s);else {const t=new V(o,this),i=t.p(this.options);t.m(s),this.k(i),this._$AH=t;}}_$AC(t){let i=T.get(t.strings);return void 0===i&&T.set(t.strings,i=new E(t)),i}S(t){d(this._$AH)||(this._$AH=[],this._$AR());const i=this._$AH;let s,e=0;for(const o of t)e===i.length?i.push(s=new N(this.M(h()),this.M(h()),this,this.options)):s=i[e],s._$AI(o),e++;e<i.length&&(this._$AR(s&&s._$AB.nextSibling,e),i.length=e);}_$AR(t=this._$AA.nextSibling,i){var s;for(null===(s=this._$AP)||void 0===s||s.call(this,!1,!0,i);t&&t!==this._$AB;){const i=t.nextSibling;t.remove(),t=i;}}setConnected(t){var i;void 0===this._$AM&&(this._$Cg=t,null===(i=this._$AP)||void 0===i||i.call(this,t));}}class S{constructor(t,i,s,e,o){this.type=1,this._$AH=w,this._$AN=void 0,this.element=t,this.name=i,this._$AM=e,this.options=o,s.length>2||""!==s[0]||""!==s[1]?(this._$AH=Array(s.length-1).fill(new String),this.strings=s):this._$AH=w;}get tagName(){return this.element.tagName}get _$AU(){return this._$AM._$AU}_$AI(t,i=this,s,e){const o=this.strings;let n=!1;if(void 0===o)t=P(this,t,i,0),n=!r(t)||t!==this._$AH&&t!==b,n&&(this._$AH=t);else {const e=t;let l,h;for(t=o[0],l=0;l<o.length-1;l++)h=P(this,e[s+l],i,l),h===b&&(h=this._$AH[l]),n||(n=!r(h)||h!==this._$AH[l]),h===w?t=w:t!==w&&(t+=(null!=h?h:"")+o[l+1]),this._$AH[l]=h;}n&&!e&&this.C(t);}C(t){t===w?this.element.removeAttribute(this.name):this.element.setAttribute(this.name,null!=t?t:"");}}class M extends S{constructor(){super(...arguments),this.type=3;}C(t){this.element[this.name]=t===w?void 0:t;}}const k=i?i.emptyScript:"";class H extends S{constructor(){super(...arguments),this.type=4;}C(t){t&&t!==w?this.element.setAttribute(this.name,k):this.element.removeAttribute(this.name);}}class I extends S{constructor(t,i,s,e,o){super(t,i,s,e,o),this.type=5;}_$AI(t,i=this){var s;if((t=null!==(s=P(this,t,i,0))&&void 0!==s?s:w)===b)return;const e=this._$AH,o=t===w&&e!==w||t.capture!==e.capture||t.once!==e.once||t.passive!==e.passive,n=t!==w&&(e===w||o);o&&this.element.removeEventListener(this.name,this,e),n&&this.element.addEventListener(this.name,this,t),this._$AH=t;}handleEvent(t){var i,s;"function"==typeof this._$AH?this._$AH.call(null!==(s=null===(i=this.options)||void 0===i?void 0:i.host)&&void 0!==s?s:this.element,t):this._$AH.handleEvent(t);}}class L{constructor(t,i,s){this.element=t,this.type=6,this._$AN=void 0,this._$AM=i,this.options=s;}get _$AU(){return this._$AM._$AU}_$AI(t){P(this,t);}}const z=window.litHtmlPolyfillSupport;null==z||z(E,N),(null!==(t=globalThis.litHtmlVersions)&&void 0!==t?t:globalThis.litHtmlVersions=[]).push("2.2.6");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */var l,o;class s extends a$1{constructor(){super(...arguments),this.renderOptions={host:this},this._$Do=void 0;}createRenderRoot(){var t,e;const i=super.createRenderRoot();return null!==(t=(e=this.renderOptions).renderBefore)&&void 0!==t||(e.renderBefore=i.firstChild),i}update(t){const i=this.render();this.hasUpdated||(this.renderOptions.isConnected=this.isConnected),super.update(t),this._$Do=x(i,this.renderRoot,this.renderOptions);}connectedCallback(){var t;super.connectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!0);}disconnectedCallback(){var t;super.disconnectedCallback(),null===(t=this._$Do)||void 0===t||t.setConnected(!1);}render(){return b}}s.finalized=!0,s._$litElement$=!0,null===(l=globalThis.litElementHydrateSupport)||void 0===l||l.call(globalThis,{LitElement:s});const n=globalThis.litElementPolyfillSupport;null==n||n({LitElement:s});(null!==(o=globalThis.litElementVersions)&&void 0!==o?o:globalThis.litElementVersions=[]).push("3.2.1");

/**
 * This fragment sets specific styles dependent on the used platform, e.g. for specific button arrangements
 */
const platformCustomization = () => {
    if (navigator.platform.includes('Win')) {
        registerStyle(r$2 `
      :root {
        --zui-internal-action-button-order: row;
        --zui-internal-action-button-alignment: flex-end;
      }
    `);
    }
    else {
        // reverse confirm-position on any other OS such as Mac OS
        registerStyle(r$2 `
      :root {
        --zui-internal-action-button-order: row-reverse;
        --zui-internal-action-button-alignment: flex-start;
      }
    `);
    }
};

const registerStyle = (style, attributeValue) => {
    const styleElement = document.createElement('style');
    styleElement.textContent = String(style);
    if (attributeValue) {
        styleElement.setAttribute('data-style-group', attributeValue);
    }
    document.head.append(styleElement);
};
/**
 * Register theming you want to use in the app
 *
 * @param {CSSResult} theme - Theme you want to register
 * @returns {void}
 */
const registerTheme = (theme) => {
    // first do the customization, to allow for override from theme
    platformCustomization();
    registerStyle(theme);
};
/**
 * Set Theme for the application
 *
 * @param {string} themeName - Name of the theming you want to set (i.e. dark, light, translucent)
 * @returns {void}
 */
const setAppTheme = (themeName) => {
    document.getElementsByTagName('html')[0].setAttribute('theme', themeName);
};
/**
 * an identity tag function meant to be `import { cssId as css }` to get nice syntax highlighting in IDE
 * @param strings
 * @param subs
 */
const cssId = (strings, ...subs) => {
    return strings.reduce((acc, currentPart, index) => {
        // "strings[0] subs[0] strings[1] subs[1] strings[2]" -> prevent to add non-existing substitute at the end
        acc = acc + currentPart + (index < strings.length - 1 ? String(subs[index]) : '');
        return acc;
    }, '');
};
/**
 * helper function to wrap rawStyle in a passed css selector
 * @param cssBody to be wrapped
 * @param selector that will wrap the cssBody, defaults to `':host'`
 */
const bindCssBodyToSelector = (cssBody, selector = ':host') => `${selector} {
${cssBody}
}
`;
/**
 * Internal function to define colors in various formats
 * @param name of the custom property
 * @param hex value of the color
 * @param suffix to be used for list representation, defaults to `rgb`
 * @returns CSSResult color definition
 */
const defineColor = (name, hex, suffix = 'rgb') => {
    const [_, r, g, b] = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const rgb = [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16)];
    return `
    --${name}-${suffix}: ${rgb.join(', ')};
    --${name}: ${hex};
  `;
};
// helper to map from ColorObj with multiple colors to a string
const mapColors = (colors) => Object.entries(colors)
    .map(([name, color]) => defineColor(name, color))
    .join('');

const colorsRawStyle$4 = cssId `
  /* Black */
  ${defineColor('BK', '#000000')}

  /* Greyscale */
    ${mapColors(greyScaleColors)}

    /* Primary Blue */
    ${mapColors(primaryBlueColors)}

    /* Secondary... */
    ${mapColors(secondaryColors)}

    /* Alternative Colors */
    ${mapColors(alternativeColors)}
`;

const iconsRawStyle$1 = cssId `
  --zui-icon-size-8: 8px;
  --zui-icon-size-12: 12px;
  --zui-icon-size-16: 16px;
  --zui-icon-size-24: 24px;
  --zui-icon-size-32: 32px;
  --zui-icon-size-40: 40px;
  --zui-icon-size-48: 48px;
  --zui-icon-size-64: 64px;
  --zui-icon-size-72: 72px;
  --zui-icon-size-80: 80px;
`;

const layoutRawStyle$1 = cssId `
  /* Grid Unit */
  --zui-gu: 8px;

  /* Spacing */
  --zui-space-extra-small: calc(var(--zui-gu) * 0.75);
  --zui-space-small: var(--zui-gu);
  --zui-space-medium: calc(var(--zui-gu) * 2);
  --zui-space-large: calc(var(--zui-gu) * 4);
`;

const visualElementsRawStyle$1 = cssId `
  /* Disabled */
  --zui-disabled-opacity: 0.5;
  --zui-selection-opacity: 0.3;

  /* Line and Border Strengths */
  --zui-line-strength-thin: 1px;
  --zui-line-strength-medium: calc(var(--zui-gu) / 4);
  --zui-line-strength-thick: calc(var(--zui-gu) / 2);

  /* Border Radius */
  --zui-border-radius-default: 3px;

  /* Shadows */
  --zui-box-shadow-default: 0px 3px 8px var(--zui-color-box-shadow-default);
  --zui-box-shadow-large: 0px 3px 12px var(--zui-color-box-shadow-default);
  --zui-box-shadow-large-inverted: 0px -3px 12px var(--zui-color-box-shadow-default);
`;

const commonStyles$1 = r$2 `
  * {
    box-sizing: border-box;
  }

  [zui-element]::selection,
  [zui-element] ::selection {
    background-color: var(--zui-color-selection-background);
  }
`;

const themeZbdsBase = r$2 `
  ${commonStyles$1}
  ${o$3(bindCssBodyToSelector(colorsRawStyle$4, ':root'))}
  ${o$3(bindCssBodyToSelector(layoutRawStyle$1, ':root'))}
  ${o$3(bindCssBodyToSelector(visualElementsRawStyle$1, ':root'))}
  ${o$3(bindCssBodyToSelector(iconsRawStyle$1, ':root'))}
`;
const themeZbdsBaseRaw = `
${colorsRawStyle$4}

${layoutRawStyle$1}

${visualElementsRawStyle$1}

${iconsRawStyle$1}
`;

const colorsRawStyle$3 = cssId `
  /* Black */
  ${defineColor('BK', '#000000')}

  /* Greyscale */
    ${mapColors(greyScaleColors$1)}

    /* Primary Blue */
    ${mapColors(primaryBlueColors$1)}

    /* Secondary... */
    ${mapColors(secondaryColors$1)}

    /* Alternative Colors */
    ${mapColors(alternativeColors$1)}
`;

const iconsRawStyle = cssId `
  --zui-icon-size-8: 8px;
  --zui-icon-size-12: 12px;
  --zui-icon-size-16: 16px;
  --zui-icon-size-24: 24px;
  --zui-icon-size-32: 32px;
  --zui-icon-size-40: 40px;
  --zui-icon-size-48: 48px;
  --zui-icon-size-64: 64px;
  --zui-icon-size-72: 72px;
  --zui-icon-size-80: 80px;
`;

const layoutRawStyle = cssId `
  /* Grid Unit */
  --zui-gu: 8px;

  /* Spacing */
  --zui-space-extra-small: calc(var(--zui-gu) * 0.75);
  --zui-space-small: var(--zui-gu);
  --zui-space-medium: calc(var(--zui-gu) * 2);
  --zui-space-large: calc(var(--zui-gu) * 4);
`;

const visualElementsRawStyle = cssId `
  /* Disabled */
  --zui-disabled-opacity: 0.5;
  --zui-selection-opacity: 0.3;

  /* Line and Border Strengths */
  --zui-line-strength-thin: 1px;
  --zui-line-strength-medium: calc(var(--zui-gu) / 4);
  --zui-line-strength-thick: calc(var(--zui-gu) / 2);

  /* Border Radius */
  --zui-border-radius-default: 3px;

  /* Shadows */
  --zui-box-shadow-default: 0px 3px 8px var(--zui-color-box-shadow-default);
  --zui-box-shadow-large: 0px 3px 12px var(--zui-color-box-shadow-default);
  --zui-box-shadow-large-inverted: 0px -3px 12px var(--zui-color-box-shadow-default);
`;

const commonStyles = r$2 `
  * {
    box-sizing: border-box;
  }

  [zui-element] {
    font: var(--zui-typography-body);
  }

  [zui-element]::selection,
  [zui-element] ::selection {
    background-color: var(--zui-color-selection-background);
  }

  zui-chat-item[emphasis='inbound']::selection,
  zui-chat-item[emphasis='inbound'] ::selection {
    color: var(--zui-color-chat-item-inbound-text);
    background-color: var(--zui-color-chat-item-inbound-bg-selection);
  }

  zui-chat-item[emphasis='outbound']::selection,
  zui-chat-item[emphasis='outbound'] ::selection {
    color: var(--zui-color-chat-item-outbound-text);
    background-color: var(--zui-color-chat-item-outbound-bg-selection);
  }
`;

const themeBaseLegacy = r$2 `
  ${commonStyles}
  ${o$3(bindCssBodyToSelector(colorsRawStyle$3, ':root'))}
  ${o$3(bindCssBodyToSelector(layoutRawStyle, ':root'))}
  ${o$3(bindCssBodyToSelector(visualElementsRawStyle, ':root'))}
  ${o$3(bindCssBodyToSelector(iconsRawStyle, ':root'))}
`;
const themeBaseLegacyRaw = `
${colorsRawStyle$3}

${layoutRawStyle}

${visualElementsRawStyle}

${iconsRawStyle}
`;

const commonStylesRawStyle$2 = cssId `
  background: var(--zui-color-app-bg);
`;

const colorsRawStyle$2 = cssId `
  /* Background Colors */
  --zui-color-app-bg: var(--zui-color-gs-10);

  --zui-color-interactive-element-bg-default-enabled: var(--zui-color-gs-30);
  --zui-color-interactive-element-bg-default-hovered: var(--zui-color-gs-40);
  --zui-color-interactive-element-bg-default-pressed: var(--zui-color-gs-50);
  --zui-color-interactive-element-bg-default-disabled: var(--zui-color-gs-30);

  --zui-color-interactive-element-bg-activated-enabled: var(--zui-color-gs-80);
  --zui-color-interactive-element-bg-activated-hovered: var(--zui-color-gs-70);
  --zui-color-interactive-element-bg-activated-pressed: var(--zui-color-gs-90);
  --zui-color-interactive-element-bg-activated-disabled: var(--zui-color-gs-80);

  --zui-color-interactive-element-bg-primary-enabled: var(--zui-color-pb-100);
  --zui-color-interactive-element-bg-primary-hovered: var(--zui-color-pb-90);
  --zui-color-interactive-element-bg-primary-pressed: var(--zui-color-pb-110);

  --zui-color-first-hierarchy-bg-default-enabled: var(--zui-color-gs-10);
  --zui-color-first-hierarchy-bg-default-hovered: var(--zui-color-gs-20);
  --zui-color-first-hierarchy-bg-default-pressed: var(--zui-color-gs-30);

  --zui-color-first-hierarchy-bg-active-enabled: var(--zui-color-gs-30);
  --zui-color-first-hierarchy-bg-active-hovered: var(--zui-color-gs-40);
  --zui-color-first-hierarchy-bg-active-pressed: var(--zui-color-gs-50);

  --zui-color-first-hierarchy-bg-active-primary-enabled: var(--zui-color-pb-100);
  --zui-color-first-hierarchy-bg-active-primary-hovered: var(--zui-color-pb-90);
  --zui-color-first-hierarchy-bg-active-primary-pressed: var(--zui-color-pb-110);

  --zui-color-second-hierarchy-bg-default-enabled: var(--zui-color-gs-20);
  --zui-color-second-hierarchy-bg-default-hovered: var(--zui-color-gs-30);
  --zui-color-second-hierarchy-bg-default-pressed: var(--zui-color-gs-40);

  --zui-color-second-hierarchy-bg-active-enabled: var(--zui-color-gs-40);
  --zui-color-second-hierarchy-bg-active-hovered: var(--zui-color-gs-50);
  --zui-color-second-hierarchy-bg-active-pressed: var(--zui-color-gs-60);

  --zui-color-second-hierarchy-bg-primary-enabled: var(--zui-color-pb-100);
  --zui-color-second-hierarchy-bg-primary-hovered: var(--zui-color-pb-110);
  --zui-color-second-hierarchy-bg-primary-pressed: var(--zui-color-pb-120);

  --zui-color-third-hierarchy-bg-default-enabled: var(--zui-color-gs-30);
  --zui-color-third-hierarchy-bg-default-hovered: var(--zui-color-gs-40);
  --zui-color-third-hierarchy-bg-default-pressed: var(--zui-color-gs-50);

  --zui-color-third-hierarchy-bg-default-primary-enabled: var(--zui-color-gs-105);
  --zui-color-third-hierarchy-bg-default-primary-hovered: var(--zui-color-gs-115);
  --zui-color-third-hierarchy-bg-default-primary-pressed: var(--zui-color-gs-120);

  --zui-color-third-hierarchy-bg-active-enabled: var(--zui-color-gs-40);
  --zui-color-third-hierarchy-bg-active-hovered: var(--zui-color-gs-50);
  --zui-color-third-hierarchy-bg-active-pressed: var(--zui-color-gs-60);

  --zui-color-fourth-hierarchy-bg-default-enabled: var(--zui-color-gs-40);
  --zui-color-fourth-hierarchy-bg-default-hovered: var(--zui-color-gs-50);
  --zui-color-fourth-hierarchy-bg-default-pressed: var(--zui-color-gs-60);

  --zui-color-text-box-bg: var(--zui-color-gs-30);

  /* Selection colors */
  --zui-color-selection-background: rgba(var(--zui-color-ac-db-110-rgb), var(--zui-selection-opacity));

  /* Dialog Box colors */
  --zui-color-dialog-box-button-bg-focused: var(--zui-color-gs-10);

  --zui-color-dialog-box-top-line: var(--zui-color-gs-90);

  --zui-color-dialog-box-separator-line: var(--zui-color-gs-40);

  /* Dialog Button colors */
  --zui-color-dialog-button-default: var(--zui-color-gs-120);

  /* ewi colors */
  --zui-color-ewi-warning: var(--zui-color-sc-y-100);
  --zui-color-ewi-info: var(--zui-color-pb-100);
  --zui-color-ewi-error: var(--zui-color-sc-r-100);
  --zui-color-ewi-question: var(--zui-color-gs-80);
  --zui-color-ewi-check: var(--zui-color-sc-g-110);

  /* Thumbnail colors */
  /* without header */
  --zui-color-thumbnail-no-header-first-hierarchy-bg-enabled: var(--zui-color-second-hierarchy-bg-default-enabled);
  --zui-color-thumbnail-no-header-first-hierarchy-bg-hovered: var(--zui-color-second-hierarchy-bg-default-hovered);
  --zui-color-thumbnail-no-header-first-hierarchy-bg-pressed: var(--zui-color-second-hierarchy-bg-default-pressed);

  --zui-color-thumbnail-no-header-second-hierarchy-bg-enabled: var(--zui-color-first-hierarchy-bg-default-enabled);
  --zui-color-thumbnail-no-header-second-hierarchy-bg-hovered: var(--zui-color-first-hierarchy-bg-default-hovered);
  --zui-color-thumbnail-no-header-second-hierarchy-bg-pressed: var(--zui-color-first-hierarchy-bg-default-pressed);

  --zui-color-thumbnail-no-header-third-hierarchy-bg-enabled: var(--zui-color-first-hierarchy-bg-default-enabled);
  --zui-color-thumbnail-no-header-third-hierarchy-bg-hovered: var(--zui-color-first-hierarchy-bg-default-hovered);
  --zui-color-thumbnail-no-header-third-hierarchy-bg-pressed: var(--zui-color-first-hierarchy-bg-default-pressed);

  /* with header */
  /* styles for header and border */
  --zui-color-thumbnail-header-first-hierarchy-bg-default-border-header-enabled: var(
    --zui-color-fourth-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-border-header-hovered: var(
    --zui-color-fourth-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-border-header-pressed: var(
    --zui-color-fourth-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-second-hierarchy-bg-default-border-header-enabled: var(
    --zui-color-first-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-border-header-hovered: var(
    --zui-color-first-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-border-header-pressed: var(
    --zui-color-first-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-third-hierarchy-bg-default-border-header-enabled: var(
    --zui-color-first-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-third-hierarchy-bg-default-border-header-hovered: var(
    --zui-color-first-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-third-hierarchy-bg-default-border-header-pressed: var(
    --zui-color-first-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-border-header-enabled: var(
    --zui-color-interactive-element-bg-activated-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-border-header-hovered: var(
    --zui-color-interactive-element-bg-activated-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-border-header-pressed: var(
    --zui-color-interactive-element-bg-activated-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-border-header-enabled: var(
    --zui-color-interactive-element-bg-primary-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-border-header-hovered: var(
    --zui-color-interactive-element-bg-primary-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-border-header-pressed: var(
    --zui-color-interactive-element-bg-primary-pressed
  );

  /* styles for image background */
  --zui-color-thumbnail-header-first-hierarchy-bg-default-image-enabled: var(
    --zui-color-second-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-image-hovered: var(
    --zui-color-second-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-image-pressed: var(
    --zui-color-second-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-second-hierarchy-bg-default-image-enabled: var(
    --zui-color-third-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-image-hovered: var(
    --zui-color-third-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-image-pressed: var(
    --zui-color-third-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-third-hierarchy-bg-default-image-enabled: var(
    --zui-color-fourth-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-third-hierarchy-bg-default-image-hovered: var(
    --zui-color-fourth-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-third-hierarchy-bg-default-image-pressed: var(
    --zui-color-fourth-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-image-enabled: var(
    --zui-color-third-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-image-hovered: var(
    --zui-color-third-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-image-pressed: var(
    --zui-color-third-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-image-enabled: var(
    --zui-color-third-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-image-hovered: var(
    --zui-color-third-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-image-pressed: var(
    --zui-color-third-hierarchy-bg-default-pressed
  );

  /* styles for icon placeholder */
  --zui-color-thumbnail-placeholder-icon: var(--zui-color-gs-80);

  /* Text Colors */
  --zui-color-text-avatar: var(--zui-color-gs-10);
  --zui-color-text-default: var(--zui-color-gs-100);
  --zui-color-text-menu-bar-default-primary: var(--zui-color-gs-50);
  --zui-color-text-on-dark-bg: var(--zui-color-gs-10);
  --zui-color-text-divider: var(--zui-color-gs-85);
  --zui-color-text-primary: var(--zui-color-pb-100);
  --zui-color-text-header: var(--zui-color-gs-120);
  --zui-color-text-secondary-line: var(--zui-color-gs-85);
  --zui-color-text-disabled: var(--zui-color-gs-100);

  /* Input Placeholder Colors */
  --zui-color-placeholder-input: var(--zui-color-gs-80);

  /* Input Bottom Line Colors */
  --zui-color-input-bottom-line-default-enabled: var(--zui-color-gs-60);
  --zui-color-input-bottom-line-default-hover: var(--zui-color-gs-120);
  --zui-color-input-bottom-line-default-focused: var(--zui-color-gs-100);
  --zui-color-input-bottom-line-default-pressed: var(--zui-color-gs-120);

  /* Textarea/Comment Colors */
  --zui-color-textarea-placeholder: var(--zui-color-gs-80);
  --zui-color-textarea-bottom-line: var(--zui-color-gs-60);
  --zui-color-textarea-bottom-line-hover: var(--zui-color-gs-120);

  /* Icon Colors */
  --zui-color-icon-foreground-default: var(--zui-color-gs-10);
  --zui-color-icon-foreground-warning: var(--zui-color-gs-110);

  --zui-color-icon-background-default: currentColor;

  --zui-color-icon-interactive-bg-default-enabled: var(--zui-color-gs-100);
  --zui-color-icon-interactive-bg-default-hovered: var(--zui-color-gs-70);
  --zui-color-icon-interactive-bg-default-pressed: var(--zui-color-gs-85);

  --zui-color-icon-interactive-bg-subtle-enabled: var(--zui-color-gs-85);
  --zui-color-icon-interactive-bg-subtle-hovered: var(--zui-color-gs-60);
  --zui-color-icon-interactive-bg-subtle-pressed: var(--zui-color-gs-70);

  --zui-color-icon-interactive-bg-highlight-enabled: var(--zui-color-gs-120);
  --zui-color-icon-interactive-bg-highlight-hovered: var(--zui-color-gs-80);
  --zui-color-icon-interactive-bg-highlight-pressed: var(--zui-color-gs-85);

  /* Highlight Colors */
  --zui-color-help: var(--zui-color-gs-80);
  --zui-color-info: var(--zui-color-pb-100);
  --zui-color-success: var(--zui-color-sc-g-110);
  --zui-color-warning: var(--zui-color-sc-y-100);
  --zui-color-error: var(--zui-color-sc-r-100);

  /* Line Colors */
  --zui-color-thin-line-default: var(--zui-color-gs-40);
  --zui-color-thin-line-highlight: var(--zui-color-gs-60);
  --zui-color-thick-line-default: var(--zui-color-gs-40);
  --zui-color-thick-line-highlight: var(--zui-color-gs-60);
  --zui-color-thick-line-primary: var(--zui-color-pb-100);

  --zui-color-interactive-element-thin-line-default-enabled: var(--zui-color-gs-60);
  --zui-color-interactive-element-thin-line-default-hovered: var(--zui-color-gs-60);
  --zui-color-interactive-element-thin-line-default-pressed: var(--zui-color-gs-60);
  --zui-color-interactive-element-thin-line-default-disabled: var(--zui-color-gs-60);

  --zui-color-interactive-element-thin-line-activated-enabled: var(--zui-color-gs-90);
  --zui-color-interactive-element-thin-line-activated-hovered: var(--zui-color-gs-90);
  --zui-color-interactive-element-thin-line-activated-pressed: var(--zui-color-gs-90);
  --zui-color-interactive-element-thin-line-activated-disabled: var(--zui-color-gs-90);

  --zui-color-interactive-element-thin-line-primary-enabled: var(--zui-color-pb-120);
  --zui-color-interactive-element-thin-line-primary-hovered: var(--zui-color-pb-120);
  --zui-color-interactive-element-thin-line-primary-pressed: var(--zui-color-pb-120);

  --zui-color-item-separator-line-first-hierarchy-default-enabled: var(--zui-color-gs-40);
  --zui-color-item-separator-line-first-hierarchy-default-hovered: var(--zui-color-gs-40);
  --zui-color-item-separator-line-first-hierarchy-default-focused: var(--zui-color-gs-100);
  --zui-color-item-separator-line-first-hierarchy-default-pressed: var(--zui-color-gs-40);

  --zui-color-item-separator-line-first-hierarchy-active-enabled: var(--zui-color-gs-40);
  --zui-color-item-separator-line-first-hierarchy-active-hovered: var(--zui-color-gs-40);
  --zui-color-item-separator-line-first-hierarchy-active-focused: var(--zui-color-gs-100);
  --zui-color-item-separator-line-first-hierarchy-active-pressed: var(--zui-color-gs-40);

  --zui-color-item-separator-line-first-hierarchy-primary-enabled: var(--zui-color-pb-120);
  --zui-color-item-separator-line-first-hierarchy-primary-hovered: var(--zui-color-pb-120);
  --zui-color-item-separator-line-first-hierarchy-primary-focused: var(--zui-color-gs-120);
  --zui-color-item-separator-line-first-hierarchy-primary-pressed: var(--zui-color-pb-120);

  --zui-color-item-separator-line-second-hierarchy-default-enabled: var(--zui-color-gs-60);
  --zui-color-item-separator-line-second-hierarchy-default-hovered: var(--zui-color-gs-60);
  --zui-color-item-separator-line-second-hierarchy-default-focused: var(--zui-color-gs-100);
  --zui-color-item-separator-line-second-hierarchy-default-pressed: var(--zui-color-gs-60);

  --zui-color-item-separator-line-second-hierarchy-active-enabled: var(--zui-color-gs-60);
  --zui-color-item-separator-line-second-hierarchy-active-hovered: var(--zui-color-gs-60);
  --zui-color-item-separator-line-second-hierarchy-active-focused: var(--zui-color-gs-100);
  --zui-color-item-separator-line-second-hierarchy-active-pressed: var(--zui-color-gs-60);

  --zui-color-item-separator-line-second-hierarchy-primary-enabled: var(--zui-color-pb-120);
  --zui-color-item-separator-line-second-hierarchy-primary-hovered: var(--zui-color-pb-120);
  --zui-color-item-separator-line-second-hierarchy-primary-focused: var(--zui-color-gs-120);
  --zui-color-item-separator-line-second-hierarchy-primary-pressed: var(--zui-color-pb-120);

  --zui-color-tooltip-border: var(--zui-color-gs-60);

  /* State Display */
  --zui-color-interactive-element-state-icon-outline-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-hovered: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-pressed: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-disabled: var(--zui-color-gs-10);

  --zui-color-interactive-element-state-icon-filled-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-filled-hovered: var(--zui-color-gs-30);
  --zui-color-interactive-element-state-icon-filled-pressed: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-filled-disabled: var(--zui-color-gs-10);

  /* Shadow Colors*/
  --zui-color-box-shadow-default: rgba(0, 0, 0, 0.2);

  /* drag-and-drop-area */
  --zui-color-drag-drop-background-first-hierarchy-default-enabled: var(--zui-color-gs-30);
  --zui-color-drag-drop-background-first-hierarchy-default-disabled: var(--zui-color-gs-30);
  --zui-color-drag-drop-background-first-hierarchy-default-hover: var(--zui-color-gs-35);
  --zui-color-drag-drop-background-first-hierarchy-default-pressed: var(--zui-color-gs-40);

  --zui-color-drag-drop-background-second-hierarchy-default-enabled: var(--zui-color-gs-10);
  --zui-color-drag-drop-background-second-hierarchy-default-disabled: var(--zui-color-gs-10);
  --zui-color-drag-drop-background-second-hierarchy-default-hover: var(--zui-color-gs-20);
  --zui-color-drag-drop-background-second-hierarchy-default-pressed: var(--zui-color-gs-30);

  --zui-color-drag-drop-background-first-hierarchy-active: var(--zui-color-gs-30);
  --zui-color-drag-drop-background-second-hierarchy-active: var(--zui-color-gs-10);

  --zui-color-drag-drop-border-default: var(--zui-color-gs-70);
  --zui-color-drag-drop-border-active: var(--zui-color-pb-100);
  --zui-color-drag-drop-font: var(--zui-color-gs-85);
  --zui-color-drag-drop-icon: var(--zui-color-gs-85);

  /* inline-message */
  --zui-color-inline-message-m-l-message-text-without-header: var(--zui-color-gs-100);
  --zui-color-inline-message-m-l-header-text: var(--zui-color-gs-100);
  --zui-color-inline-message-m-l-message-text-with-header: var(--zui-color-gs-85);
  --zui-color-inline-message-s-message-text-without-header: var(--zui-color-gs-85);

  /* radio button */
  --zui-color-radio-button-knob-enabled: var(--zui-color-gs-10);
  --zui-color-radio-button-knob-hovered: var(--zui-color-gs-30);

  --zui-color-radio-button-border-default: var(--zui-color-gs-60);
  --zui-color-radio-button-border-active: var(--zui-color-gs-90);

  /* progress ring component */
  --zui-color-progress-ring-default-background: var(--zui-color-gs-50);
  --zui-color-progress-ring-default-foreground: var(--zui-color-gs-85);
  --zui-color-progress-ring-highlight-background: var(--zui-color-gs-50);
  --zui-color-progress-ring-highlight-foreground: var(--zui-color-pb-100);
  --zui-color-progress-ring-primary-highlight-background: var(--zui-color-gs-10);
  --zui-color-progress-ring-primary-highlight-foreground: var(--zui-color-gs-10);

  --zui-color-progress-ring-default-text: var(--zui-color-gs-85);
  --zui-color-progress-ring-highlight-text: var(--zui-color-gs-85);
  --zui-color-progress-ring-primary-highlight-text: var(--zui-color-gs-10);

  /* progress bar component */
  --zui-color-progress-bar-highlight-background: var(--zui-color-gs-50);
  --zui-color-progress-bar-highlight-foreground: var(--zui-color-gs-85);

  --zui-color-progress-bar-primary-highlight-background: var(--zui-color-gs-50);
  --zui-color-progress-bar-primary-highlight-foreground: var(--zui-color-pb-100);

  --zui-color-progress-bar-striped-background: var(--zui-color-pb-50);
  --zui-color-progress-bar-striped-foreground-left-tile: var(--zui-color-pb-100);
  --zui-color-progress-bar-striped-background-right-tile: var(--zui-color-pb-90);

  /* toast notification component */
  --zui-color-toast-notification-border-color: var(--zui-color-gs-60);
  --zui-color-toast-notification-border-color-inner: var(--zui-color-gs-40);

  /* ewiq dialog component */
  --zui-color-ewiq-dialog-header-text-color: var(--zui-color-gs-120);
  --zui-color-ewiq-dialog-description-text-color: var(--zui-color-gs-85);
  --zui-color-ewiq-dialog-description-safety-text-color: var(--zui-color-gs-100);
  --zui-color-ewiq-dialog-question-text-color: var(--zui-color-gs-100);
  --zui-color-ewiq-dialog-content-text-color: var(--zui-color-gs-100);
  --zui-color-ewiq-dialog-content-background: var(--zui-color-gs-20);

  /* list item component*/
  --zui-color-list-item-first-hierarchy-default-enabled: var(--zui-color-gs-10);
  --zui-color-list-item-first-hierarchy-default-hovered: var(--zui-color-gs-20);
  --zui-color-list-item-first-hierarchy-default-focused: var(--zui-color-gs-10);
  --zui-color-list-item-first-hierarchy-default-pressed: var(--zui-color-gs-30);

  --zui-color-list-item-first-hierarchy-active-enabled: var(--zui-color-gs-30);
  --zui-color-list-item-first-hierarchy-active-hovered: var(--zui-color-gs-40);
  --zui-color-list-item-first-hierarchy-active-focused: var(--zui-color-gs-30);
  --zui-color-list-item-first-hierarchy-active-pressed: var(--zui-color-gs-50);

  --zui-color-list-item-first-hierarchy-active-primary-enabled: var(--zui-color-pb-100);
  --zui-color-list-item-first-hierarchy-active-primary-hovered: var(--zui-color-pb-90);
  --zui-color-list-item-first-hierarchy-active-primary-focused: var(--zui-color-pb-100);
  --zui-color-list-item-first-hierarchy-active-primary-pressed: var(--zui-color-pb-110);

  --zui-color-list-item-second-hierarchy-default-enabled: var(--zui-color-gs-20);
  --zui-color-list-item-second-hierarchy-default-hovered: var(--zui-color-gs-30);
  --zui-color-list-item-second-hierarchy-default-focused: var(--zui-color-gs-20);
  --zui-color-list-item-second-hierarchy-default-pressed: var(--zui-color-gs-40);

  --zui-color-list-item-second-hierarchy-active-enabled: var(--zui-color-gs-40);
  --zui-color-list-item-second-hierarchy-active-hovered: var(--zui-color-gs-50);
  --zui-color-list-item-second-hierarchy-active-focused: var(--zui-color-gs-40);
  --zui-color-list-item-second-hierarchy-active-pressed: var(--zui-color-gs-60);

  --zui-color-list-item-second-hierarchy-active-primary-enabled: var(--zui-color-pb-100);
  --zui-color-list-item-second-hierarchy-active-primary-hovered: var(--zui-color-pb-110);
  --zui-color-list-item-second-hierarchy-active-primary-focused: var(--zui-color-pb-100);
  --zui-color-list-item-second-hierarchy-active-primary-pressed: var(--zui-color-pb-120);

  /* scrollbar component */
  --zui-color-scrollbar-track: var(--zui-color-gs-60);
  --zui-color-scrollbar-handle: var(--zui-color-gs-80);
  --zui-color-scrollbar-handle-hover: var(--zui-color-gs-80);

  /* searchbar component */
  --zui-color-searchbar-search-icon: var(--zui-color-gs-85);
  --zui-color-searchbar-placeholder: var(--zui-color-gs-80);
  --zui-color-searchbar-input-background: var(--zui-color-gs-30);

  /* select component */
  --zui-color-select-button-watermark: var(--zui-color-gs-80);
  --zui-color-select-button-selected: var(--zui-color-gs-100);
  --zui-color-select-button-readonly: var(--zui-color-gs-100);

  --zui-color-select-arrow-enabled: var(--zui-color-gs-85);
  --zui-color-select-arrow-hovered: var(--zui-color-gs-100);
  --zui-color-select-arrow-focused: var(--zui-color-gs-85);
  --zui-color-select-arrow-pressed: var(--zui-color-gs-100);

  --zui-color-select-bottom-line-watermark-enabled: var(--zui-color-gs-60);
  --zui-color-select-bottom-line-watermark-hovered: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-watermark-focused: var(--zui-color-gs-60);
  --zui-color-select-bottom-line-watermark-pressed: var(--zui-color-gs-100);
  --zui-color-select-bottom-line-selected-enabled: var(--zui-color-gs-60);
  --zui-color-select-bottom-line-selected-hovered: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-selected-focused: var(--zui-color-gs-60);
  --zui-color-select-bottom-line-selected-pressed: var(--zui-color-gs-100);
  --zui-color-select-bottom-line-opened-enabled: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-hovered: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-focused: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-pressed: var(--zui-color-gs-120);

  /* menu component */
  --zui-color-menu-border: var(--zui-color-gs-60);

  --zui-color-menu-item-background-default-enabled: var(--zui-color-second-hierarchy-bg-default-enabled);
  --zui-color-menu-item-background-default-focused: var(--zui-color-second-hierarchy-bg-default-enabled);
  --zui-color-menu-item-background-default-hovered: var(--zui-color-second-hierarchy-bg-default-hovered);
  --zui-color-menu-item-background-default-pressed: var(--zui-color-second-hierarchy-bg-default-pressed);

  --zui-color-menu-item-background-selected-enabled: var(--zui-color-second-hierarchy-bg-active-enabled);
  --zui-color-menu-item-background-selected-focused: var(--zui-color-second-hierarchy-bg-active-enabled);
  --zui-color-menu-item-background-selected-hovered: var(--zui-color-second-hierarchy-bg-active-hovered);
  --zui-color-menu-item-background-selected-pressed: var(--zui-color-second-hierarchy-bg-active-pressed);

  --zui-color-menu-item-background-primary-enabled: var(--zui-color-second-hierarchy-bg-primary-enabled);
  --zui-color-menu-item-background-primary-focused: var(--zui-color-second-hierarchy-bg-primary-enabled);
  --zui-color-menu-item-background-primary-hovered: var(--zui-color-second-hierarchy-bg-primary-hovered);
  --zui-color-menu-item-background-primary-pressed: var(--zui-color-second-hierarchy-bg-primary-pressed);

  --zui-color-menu-more-menu-border-color: var(--zui-color-gs-60);
  --zui-color-menu-more-menu-box-shadow: rgba(0, 0, 0, 0.2);

  /* state dot component */
  --zui-color-state-dot-default: var(--zui-color-gs-50);

  /* state label */
  --zui-color-state-label-background-color-default: var(--zui-color-gs-35);
  --zui-color-state-label-background-color-error: rgba(var(--zui-color-sc-r-100-rgb), 0.2);
  --zui-color-state-label-background-color-progress: rgba(var(--zui-color-pb-100-rgb), 0.2);
  --zui-color-state-label-background-color-ready: rgba(var(--zui-color-sc-g-110-rgb), 0.2);
  --zui-color-state-label-background-color-warning: rgba(var(--zui-color-sc-y-100-rgb), 0.2);
  --zui-color-state-label-text-color-default: var(--zui-color-gs-100);
  --zui-color-state-label-text-color-error: var(--zui-color-sc-r-100);
  --zui-color-state-label-text-color-progress: var(--zui-color-pb-100);
  --zui-color-state-label-text-color-ready: var(--zui-color-sc-g-110);
  --zui-color-state-label-text-color-warning: var(--zui-color-sc-y-110);

  /* pill component */
  --zui-color-pill-background: var(--zui-color-gs-30);
  --zui-color-pill-border: var(--zui-color-gs-60);
  --zui-color-pill-text: var(--zui-color-gs-100);

  /* Slider */
  --zui-color-slider-track-enabled: var(--zui-color-gs-60);
  --zui-color-slider-track-disabled: var(--zui-color-gs-60);
  --zui-color-slider-track-hover: var(--zui-color-gs-60);

  --zui-color-slider-handle-fill-enabled: var(--zui-color-gs-40);
  --zui-color-slider-handle-fill-disabled: var(--zui-color-gs-30);
  --zui-color-slider-handle-fill-disabled-readonly: var(--zui-color-gs-60);
  --zui-color-slider-handle-fill-hover: var(--zui-color-gs-30);

  --zui-color-slider-handle-fill-ghost: var(--zui-color-gs-30);

  --zui-color-slider-handle-border-enabled: var(--zui-color-gs-90);
  --zui-color-slider-handle-border-disabled: var(--zui-color-gs-60);
  --zui-color-slider-handle-border-hover: var(--zui-color-gs-100);

  --zui-color-slider-handle-border-ghost: var(--zui-color-gs-60);

  --zui-color-slider-active-line-enabled: var(--zui-color-gs-90);
  --zui-color-slider-active-line-disabled: var(--zui-color-gs-60);
  --zui-color-slider-active-line-hover: var(--zui-color-gs-90);

  --zui-color-slider-step: var(--zui-color-gs-60);
  --zui-color-slider-tick-label: var(--zui-color-gs-85);

  /** slider readonly **/
  --zui-color-slider-track-readonly-enabled: var(--zui-color-gs-60);
  --zui-color-slider-track-readonly-disabled: var(--zui-color-gs-60);

  --zui-color-slider-handle-fill-readonly-enabled: var(--zui-color-gs-90);
  --zui-color-slider-handle-fill-readonly-disabled: var(--zui-color-gs-60);

  --zui-color-slider-active-line-readonly-enabled: var(--zui-color-gs-90);
  --zui-color-slider-active-line-readonly-disabled: var(--zui-color-gs-60);

  /* date picker component */
  /* grid cell component */
  --zui-color-grid-cell-background-selected: var(--zui-color-gs-80);

  --zui-color-grid-cell-text-default-enabled: var(--zui-color-gs-120);
  --zui-color-grid-cell-text-default-disabled: var(--zui-color-gs-80);
  --zui-color-grid-cell-text-default-hover: var(--zui-color-gs-100);

  --zui-color-grid-cell-text-selected: var(--zui-color-gs-10);

  --zui-color-grid-cell-text-subtle: var(--zui-color-gs-80);

  --zui-color-grid-cell-border-hover: var(--zui-color-gs-40);
  --zui-color-grid-cell-border-pressed: var(--zui-color-gs-60);

  /* user menu button component */
  /* default */
  --zui-color-user-menu-button-user-name-default: var(--zui-color-gs-100);
  --zui-color-user-menu-button-user-role-default: var(--zui-color-gs-85);
  --zui-color-user-menu-button-background-color-default: transparent;

  --zui-color-user-menu-button-user-name-hover-default: var(--zui-color-gs-70);
  --zui-color-user-menu-button-user-role-hover-default: var(--zui-color-gs-60);

  --zui-color-user-menu-button-user-name-focus-default: var(--zui-color-gs-100);
  --zui-color-user-menu-button-user-role-focus-default: var(--zui-color-gs-85);

  --zui-color-user-menu-button-user-name-active-default: var(--zui-color-gs-85);
  --zui-color-user-menu-button-user-role-active-default: var(--zui-color-gs-70);

  /* selected */
  --zui-color-user-menu-button-user-name-selected: var(--zui-color-gs-120);
  --zui-color-user-menu-button-user-role-selected: var(--zui-color-gs-100);
  --zui-color-user-menu-button-background-color-selected: var(--zui-color-gs-30);

  --zui-color-user-menu-button-user-name-hover-selected: var(--zui-color-gs-80);
  --zui-color-user-menu-button-user-role-hover-selected: var(--zui-color-gs-70);

  --zui-color-user-menu-button-user-name-focus-selected: var(--zui-color-gs-120);
  --zui-color-user-menu-button-user-role-focus-selected: var(--zui-color-gs-100);

  --zui-color-user-menu-button-user-name-active-selected: var(--zui-color-gs-85);
  --zui-color-user-menu-button-user-role-active-selected: var(--zui-color-gs-85);

  /* headerbar component */
  --zui-color-headerbar-background: var(--zui-color-gs-10);
  --zui-color-headerbar-button-divider-border-color: var(--zui-color-gs-40);

  /* headerbar icon button component */
  --zui-color-headerbar-icon-button-background-color-selected: var(--zui-color-gs-30);

  /* headerbar product name component */
  --zui-color-headerbar-product-name-color: var(--zui-color-gs-100);
  --zui-color-headerbar-product-sub-name-color: var(--zui-color-gs-85);

  /* searchbar component */
  --zui-color-searchbar-filter-divider: var(--zui-color-gs-60);
  --zui-color-searchbar-query-text: var(--zui-color-gs-100);

  /* picker header text sub component */
  --zui-color-picker-header-text-color-default: var(--zui-color-text-default);
  --zui-color-picker-header-text-color-disabled: var(--zui-color-gs-60);
  --zui-color-picker-header-text-color-hovered: var(--zui-color-gs-80);
  --zui-color-picker-header-text-color-pressed: var(--zui-color-gs-80);
  --zui-color-picker-header-text-color-active: var(--zui-color-gs-80);

  /* list accordion */
  --zui-color-list-accordion-s-closed-header-text-icon: var(--zui-color-gs-85);
  --zui-color-list-accordion-closed-header-text-icon-default: var(--zui-color-gs-100);
  --zui-color-list-accordion-closed-header-text-icon-selected: var(--zui-color-gs-120);
  --zui-color-list-accordion-closed-header-text-icon-selected-primary: var(--zui-color-gs-10);
  --zui-color-list-accordion-open-header-text-icon-default: var(--zui-color-gs-120);
  --zui-color-list-accordion-open-header-text-icon-selected: var(--zui-color-gs-120);
  --zui-color-list-accordion-open-header-text-icon-selected-primary: var(--zui-color-gs-10);

  --zui-color-list-accordion-second-line-text-default: var(--zui-color-gs-85);
  --zui-color-list-accordion-second-line-text-selected: var(--zui-color-gs-85);
  --zui-color-list-accordion-second-line-text-selected-primary: var(--zui-color-gs-50);

  --zui-color-list-accordion-header-background-default-default: var(--zui-color-gs-10);
  --zui-color-list-accordion-header-background-default-hover: var(--zui-color-gs-20);
  --zui-color-list-accordion-header-background-default-focus: var(--zui-color-gs-10);
  --zui-color-list-accordion-header-background-default-active: var(--zui-color-gs-30);

  --zui-color-list-accordion-header-background-selected-default: var(--zui-color-gs-30);
  --zui-color-list-accordion-header-background-selected-hover: var(--zui-color-gs-40);
  --zui-color-list-accordion-header-background-selected-focus: var(--zui-color-gs-30);
  --zui-color-list-accordion-header-background-selected-active: var(--zui-color-gs-50);

  --zui-color-list-accordion-header-background-selected-primary-default: var(--zui-color-pb-100);
  --zui-color-list-accordion-header-background-selected-primary-hover: var(--zui-color-pb-90);
  --zui-color-list-accordion-header-background-selected-primary-focus: var(--zui-color-pb-100);
  --zui-color-list-accordion-header-background-selected-primary-active: var(--zui-color-pb-110);

  --zui-color-list-accordion-header-top-line-default: var(--zui-color-gs-40);
  --zui-color-list-accordion-header-bottom-line-default: var(--zui-color-gs-40);
  --zui-color-list-accordion-header-bottom-line-hover: var(--zui-color-gs-40);
  --zui-color-list-accordion-header-bottom-line-focus: var(--zui-color-gs-100);
  --zui-color-list-accordion-header-bottom-line-active: var(--zui-color-gs-40);

  /* list accordion item */
  --zui-color-list-accordion-item-primary-text-default: var(--zui-color-gs-100);
  --zui-color-list-accordion-item-primary-text-selected: var(--zui-color-gs-120);
  --zui-color-list-accordion-item-primary-text-selected-primary: var(--zui-color-gs-10);

  --zui-color-list-accordion-item-background-default: var(--zui-color-list-item-second-hierarchy-default-enabled);
  --zui-color-list-accordion-item-background-selected: var(--zui-color-list-item-second-hierarchy-active-enabled);
  --zui-color-list-accordion-item-background-selected-primary: var(
    --zui-color-list-item-second-hierarchy-active-primary-enabled
  );

  --zui-color-list-accordion-item-border-bottom-default: var(--zui-color-gs-60);
  --zui-color-list-accordion-item-border-bottom-last-default: var(--zui-color-gs-40);
  --zui-color-list-accordion-item-border-bottom-default-hover: var(--zui-color-gs-60);
  --zui-color-list-accordion-item-border-bottom-default-focus: var(--zui-color-gs-100);
  --zui-color-list-accordion-item-border-bottom-default-active: var(--zui-color-gs-60);

  --zui-color-list-accordion-item-border-bottom-selected: var(--zui-color-gs-60);
  --zui-color-list-accordion-item-border-bottom-selected-hover: var(--zui-color-gs-60);
  --zui-color-list-accordion-item-border-bottom-selected-focus: var(--zui-color-gs-100);
  --zui-color-list-accordion-item-border-bottom-selected-active: var(--zui-color-gs-60);

  --zui-color-list-accordion-item-border-bottom-selected-primary: var(--zui-color-pb-120);
  --zui-color-list-accordion-item-border-bottom-selected-primary-hover: var(--zui-color-pb-120);
  --zui-color-list-accordion-item-border-bottom-selected-primary-focus: var(--zui-color-gs-120);
  --zui-color-list-accordion-item-border-bottom-selected-primary-active: var(--zui-color-pb-120);

  --zui-color-list-accordion-item-background-default-hover: var(--zui-color-list-item-second-hierarchy-default-hovered);
  --zui-color-list-accordion-item-background-selected-hover: var(--zui-color-list-item-second-hierarchy-active-hovered);
  --zui-color-list-accordion-item-background-selected-primary-hover: var(
    --zui-color-list-item-second-hierarchy-active-primary-hovered
  );

  --zui-color-list-accordion-item-background-default-focus: var(--zui-color-list-item-second-hierarchy-default-focused);
  --zui-color-list-accordion-item-background-selected-focus: var(--zui-color-list-item-second-hierarchy-active-focused);
  --zui-color-list-accordion-item-background-selected-primary-focus: var(
    --zui-color-list-item-second-hierarchy-active-primary-focused
  );

  --zui-color-list-accordion-item-background-default-active: var(
    --zui-color-list-item-second-hierarchy-default-pressed
  );
  --zui-color-list-accordion-item-background-selected-active: var(
    --zui-color-list-item-second-hierarchy-active-pressed
  );
  --zui-color-list-accordion-item-background-selected-primary-active: var(
    --zui-color-list-item-second-hierarchy-active-primary-pressed
  );

  /* pagination dot */
  --zui-color-pagination-dot-background-default: var(--zui-color-gs-50);
  --zui-color-pagination-dot-background-selected: var(--zui-color-pb-100);

  /* menu tab item */
  --zui-color-menu-tab-item-default-background-active: var(--zui-color-gs-30);
  --zui-color-menu-tab-item-default-background-focus: var(--zui-color-gs-10);
  --zui-color-menu-tab-item-default-background-hover: var(--zui-color-gs-20);
  --zui-color-menu-tab-item-default-background: var(--zui-color-gs-10);
  --zui-color-menu-tab-item-default: var(--zui-color-gs-100);

  --zui-color-menu-tab-item-selected-background: var(--zui-color-gs-100);
  --zui-color-menu-tab-item-selected-border-bottom: var(--zui-color-pb-100);
  --zui-color-menu-tab-item-selected: var(--zui-color-gs-120);

  /* table */
  /* header */
  --zui-color-table-header-first-default-enabled-background: var(--zui-color-gs-30);
  --zui-color-table-header-first-default-enabled-borders: var(--zui-color-gs-60);
  --zui-color-table-header-first-default-enabled-content: var(--zui-color-gs-85);
  --zui-color-table-header-first-default-disabled-background: var(--zui-color-gs-30);
  --zui-color-table-header-first-default-disabled-borders: var(--zui-color-gs-60);
  --zui-color-table-header-first-default-disabled-content: rgba(var(--zui-color-gs-85-rgb), 0.5);
  --zui-color-table-header-first-default-hover-background: var(--zui-color-gs-40);
  --zui-color-table-header-first-default-hover-borders: var(--zui-color-gs-60);
  --zui-color-table-header-first-default-hover-content: var(--zui-color-gs-85);
  --zui-color-table-header-first-default-focused-background: var(--zui-color-gs-30);
  --zui-color-table-header-first-default-focused-borders: var(--zui-color-gs-60);
  --zui-color-table-header-first-default-focused-content: var(--zui-color-gs-85);
  --zui-color-table-header-first-default-pressed-background: var(--zui-color-gs-50);
  --zui-color-table-header-first-default-pressed-borders: var(--zui-color-gs-60);
  --zui-color-table-header-first-default-pressed-content: var(--zui-color-gs-85);

  /* body */
  /* hierarchy - first */
  --zui-color-table-body-first-default-enabled-background: var(--zui-color-gs-10);
  --zui-color-table-body-first-default-enabled-border: var(--zui-color-gs-40);
  --zui-color-table-body-first-default-enabled-content: var(--zui-color-gs-100);
  --zui-color-table-body-first-default-disabled-background: rgba(var(--zui-color-gs-10-rgb), 0.5);
  --zui-color-table-body-first-default-disabled-border: rgba(var(--zui-color-gs-40-rgb), 0.5);
  --zui-color-table-body-first-default-disabled-content: rgba(var(--zui-color-gs-100-rgb), 0.5);
  --zui-color-table-body-first-default-hover-background: var(--zui-color-gs-20);
  --zui-color-table-body-first-default-hover-border: var(--zui-color-gs-40);
  --zui-color-table-body-first-default-hover-content: var(--zui-color-gs-100);
  --zui-color-table-body-first-default-pressed-background: var(--zui-color-gs-30);
  --zui-color-table-body-first-default-pressed-border: var(--zui-color-gs-40);
  --zui-color-table-body-first-default-pressed-content: var(--zui-color-gs-100);
  --zui-color-table-body-first-selected-enabled-background: var(--zui-color-gs-30);
  --zui-color-table-body-first-selected-enabled-border: var(--zui-color-gs-40);
  --zui-color-table-body-first-selected-enabled-content: var(--zui-color-gs-120);
  --zui-color-table-body-first-selected-disabled-background: rgba(var(--zui-color-gs-30-rgb), 0.5);
  --zui-color-table-body-first-selected-disabled-border: rgba(var(--zui-color-gs-40-rgb), 0.5);
  --zui-color-table-body-first-selected-disabled-content: rgba(var(--zui-color-gs-120-rgb), 0.5);
  --zui-color-table-body-first-selected-hover-background: var(--zui-color-gs-40);
  --zui-color-table-body-first-selected-hover-border: var(--zui-color-gs-40);
  --zui-color-table-body-first-selected-hover-content: var(--zui-color-gs-120);
  --zui-color-table-body-first-selected-pressed-background: var(--zui-color-gs-50);
  --zui-color-table-body-first-selected-pressed-border: var(--zui-color-gs-40);
  --zui-color-table-body-first-selected-pressed-content: var(--zui-color-gs-120);

  /* hierarchy - second */
  --zui-color-table-body-second-default-enabled-background: var(--zui-color-gs-20);
  --zui-color-table-body-second-default-enabled-border: var(--zui-color-gs-60);
  --zui-color-table-body-second-default-enabled-content: var(--zui-color-gs-100);
  --zui-color-table-body-second-default-disabled-background: rgba(var(--zui-color-gs-20-rgb), 0.5);
  --zui-color-table-body-second-default-disabled-border: rgba(var(--zui-color-gs-60-rgb), 0.5);
  --zui-color-table-body-second-default-disabled-content: rgba(var(--zui-color-gs-100-rgb), 0.5);
  --zui-color-table-body-second-default-hover-background: var(--zui-color-gs-30);
  --zui-color-table-body-second-default-hover-border: var(--zui-color-gs-60);
  --zui-color-table-body-second-default-hover-content: var(--zui-color-gs-100);
  --zui-color-table-body-second-default-pressed-background: var(--zui-color-gs-40);
  --zui-color-table-body-second-default-pressed-border: var(--zui-color-gs-60);
  --zui-color-table-body-second-default-pressed-content: var(--zui-color-gs-100);
  --zui-color-table-body-second-selected-enabled-background: var(--zui-color-gs-30);
  --zui-color-table-body-second-selected-enabled-border: var(--zui-color-gs-60);
  --zui-color-table-body-second-selected-enabled-content: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-disabled-background: rgba(var(--zui-color-gs-30-rgb), 0.5);
  --zui-color-table-body-second-selected-disabled-border: rgba(var(--zui-color-gs-60-rgb), 0.5);
  --zui-color-table-body-second-selected-disabled-content: rgba(var(--zui-color-gs-120-rgb), 0.5);
  --zui-color-table-body-second-selected-hover-background: var(--zui-color-gs-40);
  --zui-color-table-body-second-selected-hover-border: var(--zui-color-gs-60);
  --zui-color-table-body-second-selected-hover-content: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-pressed-background: var(--zui-color-gs-50);
  --zui-color-table-body-second-selected-pressed-border: var(--zui-color-gs-60);
  --zui-color-table-body-second-selected-pressed-content: var(--zui-color-gs-120);

  /* title stack */
  --zui-color-title-stack-label: var(--zui-color-gs-85);
  --zui-color-title-stack-headline: var(--zui-color-gs-100);
  --zui-color-title-stack-separator: var(--zui-color-gs-60);
  --zui-color-title-stack-meta: var(--zui-color-gs-85);

  /* toggle switch */
  --zui-color-toggle-switch-default-background-color: var(--zui-color-gs-50);
  --zui-color-toggle-switch-default-background-color-disabled: var(--zui-color-gs-50);
  --zui-color-toggle-switch-default-background-color-hover: var(--zui-color-gs-40);
  --zui-color-toggle-switch-default-background-color-focus: var(--zui-color-gs-50);
  --zui-color-toggle-switch-default-background-color-active: var(--zui-color-gs-60);

  --zui-color-toggle-switch-default-border-color: var(--zui-color-gs-70);
  --zui-color-toggle-switch-default-border-color-disabled: var(--zui-color-gs-70);

  --zui-color-toggle-switch-default-checked-background-color: var(--zui-color-gs-80);
  --zui-color-toggle-switch-default-checked-background-color-disabled: var(--zui-color-gs-80);
  --zui-color-toggle-switch-default-checked-background-color-hover: var(--zui-color-gs-70);
  --zui-color-toggle-switch-default-checked-background-color-focus: var(--zui-color-gs-80);
  --zui-color-toggle-switch-default-checked-background-color-active: var(--zui-color-gs-90);

  --zui-color-toggle-switch-default-checked-border-color: var(--zui-color-gs-90);
  --zui-color-toggle-switch-default-checked-border-color-disabled: var(--zui-color-gs-90);

  --zui-color-toggle-switch-primary-checked-background-color: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-disabled: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-hover: var(--zui-color-pb-90);
  --zui-color-toggle-switch-primary-checked-background-color-focus: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-active: var(--zui-color-pb-110);

  --zui-color-toggle-switch-primary-checked-border-color: var(--zui-color-pb-120);
  --zui-color-toggle-switch-primary-checked-border-color-disabled: var(--zui-color-pb-120);

  /* about screen */
  --zui-color-about-screen-header-background-color-default: var(--zui-color-gs-20);
  --zui-color-about-screen-content-background-color-default: var(--zui-color-gs-10);
  --zui-color-about-screen-footer-background-color-default: var(--zui-color-gs-10);

  --zui-color-about-screen-header-background-color-inverted: var(--zui-color-gs-10);
  --zui-color-about-screen-content-background-color-inverted: var(--zui-color-gs-20);
  --zui-color-about-screen-footer-background-color-inverted: var(--zui-color-gs-20);

  --zui-color-about-screen-software-icon-color: var(--zui-color-gs-100);
  --zui-color-about-screen-software-name-color: var(--zui-color-gs-100);
  --zui-color-about-screen-software-version-color: var(--zui-color-gs-85);
  --zui-color-about-screen-copyright-claim-color: var(--zui-color-gs-85);
  --zui-color-about-screen-licence-title-color: var(--zui-color-gs-120);
  --zui-color-about-screen-small-licence-title-color: var(--zui-color-gs-85);

  /* content tab default item */
  /* text color for emphasis: default */
  --zui-content-tab-default-item-default-text-enabled: var(--zui-color-gs-85);
  --zui-content-tab-default-item-default-text-disabled: var(--zui-color-gs-85);
  --zui-content-tab-default-item-default-text-hovered: var(--zui-color-gs-100);
  --zui-content-tab-default-item-default-text-focused: var(--zui-color-gs-85);
  --zui-content-tab-default-item-default-text-pressed: var(--zui-color-gs-100);

  /* text color for emphasis: selected */
  --zui-content-tab-default-item-selected-text-enabled: var(--zui-color-gs-120);
  --zui-content-tab-default-item-selected-text-disabled: var(--zui-color-gs-120);
  --zui-content-tab-default-item-selected-text-hovered: var(--zui-color-gs-120);
  --zui-content-tab-default-item-selected-text-focused: var(--zui-color-gs-120);
  --zui-content-tab-default-item-selected-text-pressed: var(--zui-color-gs-120);

  /* background for emphasis: default */
  --zui-content-tab-default-item-default-background-enabled: var(--zui-color-gs-30);
  --zui-content-tab-default-item-default-background-disabled: var(--zui-color-gs-30);
  --zui-content-tab-default-item-default-background-hovered: var(--zui-color-gs-40);
  --zui-content-tab-default-item-default-background-focused: var(--zui-color-gs-30);
  --zui-content-tab-default-item-default-background-pressed: var(--zui-color-gs-50);

  /* background for emphasis: selected and hierarchy level: 1 */
  --zui-content-tab-default-item-selected-1-background-enabled: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-1-background-disabled: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-1-background-hovered: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-1-background-focused: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-1-background-pressed: var(--zui-color-gs-10);

  /* background for emphasis: selected and hierarchy level: 2 */
  --zui-content-tab-default-item-selected-2-background-enabled: var(--zui-color-gs-20);
  --zui-content-tab-default-item-selected-2-background-disabled: var(--zui-color-gs-20);
  --zui-content-tab-default-item-selected-2-background-hovered: var(--zui-color-gs-20);
  --zui-content-tab-default-item-selected-2-background-focused: var(--zui-color-gs-20);
  --zui-content-tab-default-item-selected-2-background-pressed: var(--zui-color-gs-20);

  /* content tab highlight item */
  /* text color for emphasis: default */
  --zui-content-tab-highlight-item-default-text-enabled: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-default-text-disabled: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-default-text-hovered: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-default-text-focused: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-default-text-pressed: var(--zui-color-gs-100);

  /* text color for emphasis: selected */
  --zui-content-tab-highlight-item-selected-text-enabled: var(--zui-color-gs-120);
  --zui-content-tab-highlight-item-selected-text-disabled: var(--zui-color-gs-120);
  --zui-content-tab-highlight-item-selected-text-hovered: var(--zui-color-gs-120);
  --zui-content-tab-highlight-item-selected-text-focused: var(--zui-color-gs-120);
  --zui-content-tab-highlight-item-selected-text-pressed: var(--zui-color-gs-120);

  /* background for emphasis: default */
  --zui-content-tab-highlight-item-default-background-enabled: var(--zui-color-gs-30);
  --zui-content-tab-highlight-item-default-background-disabled: var(--zui-color-gs-30);
  --zui-content-tab-highlight-item-default-background-hovered: var(--zui-color-gs-40);
  --zui-content-tab-highlight-item-default-background-focused: var(--zui-color-gs-30);
  --zui-content-tab-highlight-item-default-background-pressed: var(--zui-color-gs-50);

  /* background for emphasis: selected and hierarchy level: 1 */
  --zui-content-tab-highlight-item-selected-1-background-enabled: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-1-background-disabled: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-1-background-hovered: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-1-background-focused: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-1-background-pressed: var(--zui-color-gs-10);

  /* background for emphasis: selected and hierarchy level: 2 */
  --zui-content-tab-highlight-item-selected-2-background-enabled: var(--zui-color-gs-20);
  --zui-content-tab-highlight-item-selected-2-background-disabled: var(--zui-color-gs-20);
  --zui-content-tab-highlight-item-selected-2-background-hovered: var(--zui-color-gs-20);
  --zui-content-tab-highlight-item-selected-2-background-focused: var(--zui-color-gs-20);
  --zui-content-tab-highlight-item-selected-2-background-pressed: var(--zui-color-gs-20);

  /* border-top */
  --zui-content-tab-highlight-item-selected-border: var(--zui-color-gs-95);

  /* content tab image item */
  /* text color for emphasis: default */
  --zui-content-tab-image-item-default-text-enabled: var(--zui-color-gs-80);
  --zui-content-tab-image-item-default-text-disabled: var(--zui-color-gs-80);
  --zui-content-tab-image-item-default-text-hovered: var(--zui-color-gs-50);
  --zui-content-tab-image-item-default-text-focused: var(--zui-color-gs-80);
  --zui-content-tab-image-item-default-text-pressed: var(--zui-color-gs-50);

  /* background for emphasis: default */
  --zui-content-tab-image-item-default-background-enabled: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-disabled: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-hovered: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-focused: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-pressed: var(--zui-color-gs-115);

  /* text color for emphasis: selected */
  --zui-content-tab-image-item-selected-text-enabled: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-disabled: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-hovered: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-focused: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-pressed: var(--zui-color-gs-10);

  /* background for emphasis: selected */
  --zui-content-tab-image-item-selected-background-enabled: var(--zui-color-gs-105);
  --zui-content-tab-image-item-selected-background-disabled: var(--zui-color-gs-105);
  --zui-content-tab-image-item-selected-background-hovered: var(--zui-color-gs-105);
  --zui-content-tab-image-item-selected-background-focused: var(--zui-color-gs-105);
  --zui-content-tab-image-item-selected-background-pressed: var(--zui-color-gs-105);

  /* content tab bar */
  --zui-content-tab-bar-rectangle-background: var(--zui-color-gs-30);

  /* color override for the close icon (always dark mode) */
  /* emphasis component: default = emphasis icon: muted */
  --zui-content-tab-image-item-interactive-item-default-enabled: var(--zui-color-gs-80);
  --zui-content-tab-image-item-interactive-item-default-hovered: var(--zui-color-gs-90);
  --zui-content-tab-image-item-interactive-item-default-pressed: var(--zui-color-gs-70);

  /* emphasis component: selected = emphasis icon: highlight */
  --zui-content-tab-image-item-interactive-item-selected-enabled: var(--zui-color-gs-10);
  --zui-content-tab-image-item-interactive-item-selected-hovered: var(--zui-color-gs-70);
  --zui-content-tab-image-item-interactive-item-selected-pressed: var(--zui-color-gs-60);

  /* step indicator item */
  --zui-step-indicator-item-text-color-next: var(--zui-color-gs-85);
  --zui-step-indicator-item-text-color-selected: var(--zui-color-gs-120);
  --zui-step-indicator-item-text-color-visited: var(--zui-color-gs-85);

  --zui-step-indicator-item-border-color-next: var(--zui-color-gs-80);
  --zui-step-indicator-item-border-color-selected: var(--zui-color-pb-100);
  --zui-step-indicator-item-border-color-visited: var(--zui-color-pb-70);

  /* focus view bar */
  --zui-focus-view-bar-background-color: var(--zui-color-gs-10);

  /* tag component */
  --zui-color-tag-background-enabled: var(--zui-color-gs-30);
  --zui-color-tag-background-hovered: var(--zui-color-gs-40);
  --zui-color-tag-background-active: var(--zui-color-gs-50);
  --zui-color-tag-border: var(--zui-color-gs-60);
  --zui-color-tag-text: var(--zui-color-gs-100);

  /* interactive text */
  --zui-color-interactive-text-default-enabled: var(--zui-color-gs-100);
  --zui-color-interactive-text-default-hovered: var(--zui-color-gs-70);
  --zui-color-interactive-text-default-focused: var(--zui-color-gs-100);
  --zui-color-interactive-text-default-pressed: var(--zui-color-gs-85);

  --zui-color-interactive-text-subtle-enabled: var(--zui-color-gs-85);
  --zui-color-interactive-text-subtle-hovered: var(--zui-color-gs-60);
  --zui-color-interactive-text-subtle-focused: var(--zui-color-gs-85);
  --zui-color-interactive-text-subtle-pressed: var(--zui-color-gs-70);

  --zui-color-interactive-text-highlight-enabled: var(--zui-color-gs-120);
  --zui-color-interactive-text-highlight-hovered: var(--zui-color-gs-80);
  --zui-color-interactive-text-highlight-focused: var(--zui-color-gs-120);
  --zui-color-interactive-text-highlight-pressed: var(--zui-color-gs-85);

  --zui-color-interactive-text-primary-highlight-enabled: var(--zui-color-pb-100);
  --zui-color-interactive-text-primary-highlight-hovered: var(--zui-color-pb-80);
  --zui-color-interactive-text-primary-highlight-focused: var(--zui-color-pb-100);
  --zui-color-interactive-text-primary-highlight-pressed: var(--zui-color-pb-90);

  /* quiet link */
  --zui-color-quiet-link-default-enabled: var(--zui-color-gs-100);
  --zui-color-quiet-link-default-hovered: var(--zui-color-gs-70);
  --zui-color-quiet-link-default-focused: var(--zui-color-gs-100);
  --zui-color-quiet-link-default-active: var(--zui-color-gs-85);
  --zui-color-quiet-link-default-visited: var(--zui-color-gs-100);

  --zui-color-quiet-link-subtle-enabled: var(--zui-color-gs-85);
  --zui-color-quiet-link-subtle-hovered: var(--zui-color-gs-60);
  --zui-color-quiet-link-subtle-focused: var(--zui-color-gs-85);
  --zui-color-quiet-link-subtle-active: var(--zui-color-gs-70);
  --zui-color-quiet-link-subtle-visited: var(--zui-color-gs-85);

  --zui-color-quiet-link-highlight-enabled: var(--zui-color-gs-120);
  --zui-color-quiet-link-highlight-hovered: var(--zui-color-gs-80);
  --zui-color-quiet-link-highlight-focused: var(--zui-color-gs-120);
  --zui-color-quiet-link-highlight-active: var(--zui-color-gs-85);
  --zui-color-quiet-link-highlight-visited: var(--zui-color-gs-120);

  --zui-color-quiet-link-primary-highlight-enabled: var(--zui-color-pb-100);
  --zui-color-quiet-link-primary-highlight-hovered: var(--zui-color-pb-80);
  --zui-color-quiet-link-primary-highlight-focused: var(--zui-color-pb-100);
  --zui-color-quiet-link-primary-highlight-active: var(--zui-color-pb-90);
  --zui-color-quiet-link-primary-highlight-visited: var(--zui-color-pb-100);

  /* time picker input */
  --zui-time-picker-input-border-bottom-disabled-color: rgba(var(--zui-color-gs-60-rgb), var(--zui-disabled-opacity));

  /* time picker cell */
  --zui-time-picker-cell-background-color: var(--zui-color-gs-30);
  --zui-time-picker-cell-background-color-hovered: var(--zui-color-gs-40);
  --zui-time-picker-cell-background-color-focused: var(--zui-color-gs-30);
  --zui-time-picker-cell-background-color-pressed: var(--zui-color-gs-50);

  --zui-time-picker-cell-border-color: var(--zui-color-gs-60);
  --zui-time-picker-cell-border-color-hovered: var(--zui-color-gs-60);
  --zui-time-picker-cell-border-color-focused: var(--zui-color-gs-60);
  --zui-time-picker-cell-border-color-pressed: var(--zui-color-gs-60);

  --zui-time-picker-cell-text-color: var(--zui-color-gs-120);
  --zui-time-picker-cell-text-color-hovered: var(--zui-color-gs-120);
  --zui-time-picker-cell-text-color-focused: var(--zui-color-gs-120);
  --zui-time-picker-cell-text-color-pressed: var(--zui-color-gs-120);

  /* time picker cell divider */
  --zui-time-picker-cell-divider-color: var(--zui-color-gs-100);

  /* content accordion details */
  /* background */
  --zui-content-accordion-details-background: var(--zui-color-gs-10);

  /* bottom line */
  --zui-content-accordion-details-bottom-line-enabled-disabled-hovered-pressed: var(--zui-color-gs-40);
  --zui-content-accordion-details-bottom-line-focused: var(--zui-color-gs-100);

  /* standalone for size s + m + l */
  /* closed */
  --zui-content-accordion-details-standalone-closed-text-icon-enabled: var(--zui-color-gs-85);
  --zui-content-accordion-details-standalone-closed-text-icon-disabled: var(--zui-color-gs-85);
  --zui-content-accordion-details-standalone-closed-text-icon-hovered: var(--zui-color-gs-60);
  --zui-content-accordion-details-standalone-closed-text-icon-focused: var(--zui-color-gs-85);
  --zui-content-accordion-details-standalone-closed-text-icon-pressed: var(--zui-color-gs-70);

  /* open */
  --zui-content-accordion-details-standalone-open-text-icon-enabled: var(--zui-color-gs-120);
  --zui-content-accordion-details-standalone-open-text-icon-disabled: var(--zui-color-gs-120);
  --zui-content-accordion-details-standalone-open-text-icon-hovered: var(--zui-color-gs-80);
  --zui-content-accordion-details-standalone-open-text-icon-focused: var(--zui-color-gs-120);
  --zui-content-accordion-details-standalone-open-text-icon-pressed: var(--zui-color-gs-85);

  /* integrated for size m + s */
  /* closed */
  --zui-content-accordion-details-integrated-s-m-closed-text-enabled: var(--zui-color-gs-100);
  --zui-content-accordion-details-integrated-s-m-closed-text-disabled: var(--zui-color-gs-100);
  --zui-content-accordion-details-integrated-s-m-closed-text-hovered: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-s-m-closed-text-focused: var(--zui-color-gs-100);
  --zui-content-accordion-details-integrated-s-m-closed-text-pressed: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-s-m-closed-icon-enabled: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-s-m-closed-icon-disabled: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-s-m-closed-icon-hovered: var(--zui-color-gs-60);
  --zui-content-accordion-details-integrated-s-m-closed-icon-focused: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-s-m-closed-icon-pressed: var(--zui-color-gs-70);
  /* open */
  --zui-content-accordion-details-integrated-s-m-open-text-icon-enabled: var(--zui-color-gs-120);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-disabled: var(--zui-color-gs-120);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-hovered: var(--zui-color-gs-80);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-focused: var(--zui-color-gs-120);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-pressed: var(--zui-color-gs-85);

  /* integrated for size l */
  /* closed */
  --zui-content-accordion-details-integrated-l-closed-text-enabled: var(--zui-color-gs-100);
  --zui-content-accordion-details-integrated-l-closed-text-disabled: var(--zui-color-gs-100);
  --zui-content-accordion-details-integrated-l-closed-text-hovered: var(--zui-color-gs-80);
  --zui-content-accordion-details-integrated-l-closed-text-focused: var(--zui-color-gs-100);
  --zui-content-accordion-details-integrated-l-closed-text-pressed: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-l-closed-icon-enabled: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-l-closed-icon-disabled: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-l-closed-icon-hovered: var(--zui-color-gs-60);
  --zui-content-accordion-details-integrated-l-closed-icon-focused: var(--zui-color-gs-85);
  --zui-content-accordion-details-integrated-l-closed-icon-pressed: var(--zui-color-gs-70);
  /* open */
  --zui-content-accordion-details-integrated-l-open-text-icon-enabled: var(--zui-color-gs-120);
  --zui-content-accordion-details-integrated-l-open-text-icon-disabled: var(--zui-color-gs-120);
  --zui-content-accordion-details-integrated-l-open-text-icon-hovered: var(--zui-color-gs-80);
  --zui-content-accordion-details-integrated-l-open-text-icon-focused: var(--zui-color-gs-120);
  --zui-content-accordion-details-integrated-l-open-text-icon-pressed: var(--zui-color-gs-85);

  /* ~~ Expander ~~ */
  /* background */
  /* hierarchy first */
  --zui-color-expander-bg-first-hierarchy-enabled: var(--zui-color-gs-10);
  --zui-color-expander-bg-first-hierarchy-disabled: var(--zui-color-gs-10);
  --zui-color-expander-bg-first-hierarchy-hover: var(--zui-color-gs-20);
  --zui-color-expander-bg-first-hierarchy-focus: var(--zui-color-gs-10);
  --zui-color-expander-bg-first-hierarchy-active: var(--zui-color-gs-30);
  /* hierarchy second */
  --zui-color-expander-bg-second-hierarchy-enabled: var(--zui-color-gs-20);
  --zui-color-expander-bg-second-hierarchy-disabled: var(--zui-color-gs-20);
  --zui-color-expander-bg-second-hierarchy-hover: var(--zui-color-gs-30);
  --zui-color-expander-bg-second-hierarchy-focus: var(--zui-color-gs-20);
  --zui-color-expander-bg-second-hierarchy-active: var(--zui-color-gs-40);

  /* icon */
  --zui-color-expander-icon-color: var(--zui-color-gs-80);

  /* ~~ Text Link ~~ */
  --zui-color-text-link-subtle-enabled: var(--zui-color-gs-85);
  --zui-color-text-link-subtle-hover: var(--zui-color-gs-60);
  --zui-color-text-link-subtle-focused: var(--zui-color-gs-85);
  --zui-color-text-link-subtle-active: var(--zui-color-gs-70);

  --zui-color-text-link-default-enabled: var(--zui-color-gs-100);
  --zui-color-text-link-default-hover: var(--zui-color-gs-70);
  --zui-color-text-link-default-focused: var(--zui-color-gs-100);
  --zui-color-text-link-default-active: var(--zui-color-gs-85);

  --zui-color-text-link-highlight-enabled: var(--zui-color-gs-120);
  --zui-color-text-link-highlight-hover: var(--zui-color-gs-80);
  --zui-color-text-link-highlight-focused: var(--zui-color-gs-120);
  --zui-color-text-link-highlight-active: var(--zui-color-gs-85);

  --zui-color-text-link-primary-highlight-enabled: var(--zui-color-pb-100);
  --zui-color-text-link-primary-highlight-hover: var(--zui-color-pb-80);
  --zui-color-text-link-primary-highlight-focused: var(--zui-color-pb-100);
  --zui-color-text-link-primary-highlight-active: var(--zui-color-pb-90);

  --zui-color-text-link-visited: var(--zui-color-ac-db-110);

  /* Chat Item */
  /* inbound */
  --zui-color-chat-item-inbound-bg: var(--zui-color-gs-40);
  --zui-color-chat-item-inbound-text: var(--zui-color-gs-100);
  --zui-color-chat-item-inbound-bg-selection: rgba(var(--zui-color-ac-db-110-rgb), 0.4);

  /* outbound */
  --zui-color-chat-item-outbound-bg: var(--zui-color-ac-db-110);
  --zui-color-chat-item-outbound-text: var(--zui-color-gs-10);
  --zui-color-chat-item-outbound-bg-selection: rgba(var(--zui-color-gs-100-rgb), 0.3);

  /* incidentials */
  --zui-color-chat-item-delivery-text: var(--zui-color-gs-85);
  --zui-color-chat-item-delivery-bg-selection: rgba(var(--zui-color-ac-db-110-rgb), 0.3);
  --zui-color-chat-item-divider: var(--zui-color-gs-60);

  /* Multiline Input Field */
  --zui-color-multiline-textfield-border-enabled: var(--zui-color-gs-60);
  --zui-color-multiline-textfield-border-hover: var(--zui-color-gs-120);
  --zui-color-multiline-textfield-border-focused: var(--zui-color-gs-120);
  --zui-color-multiline-textfield-border-pressed: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-border-error: var(--zui-color-sc-r-100);
  --zui-color-multiline-textfield-border-readonly: transparent;
  --zui-color-multiline-textfield-border-disabled: rgba(var(--zui-color-gs-60-rgb), 0.5);

  --zui-color-multiline-textfield-watermark-enabled: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-hover: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-focused: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-pressed: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-error: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-readonly: transparent;
  --zui-color-multiline-textfield-watermark-disabled: rgba(var(--zui-color-gs-80-rgb), 0.5);

  --zui-color-multiline-textfield-input-enabled: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-input-hover: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-input-focused: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-input-pressed: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-input-error: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-input-readonly: var(--zui-color-gs-100);
  --zui-color-multiline-textfield-input-disabled: rgba(var(--zui-color-gs-100-rgb), 0.5);

  --zui-color-multiline-textfield-limit-indicator-enabled: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-hover: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-focused: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-pressed: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-error: var(--zui-color-sc-r-100);
  --zui-color-multiline-textfield-limit-indicator-readonly: transparent;
  --zui-color-multiline-textfield-limit-indicator-disabled: rgba(var(--zui-color-gs-80-rgb), 0.5);

  --zui-color-multiline-textfield-text-selection: rgba(var(--zui-color-ac-db-110-rgb), 0.3);

  /* Checkbox */
  --zui-color-checkbox-bg-default-enabled: var(--zui-color-gs-30);
  --zui-color-checkbox-bg-default-disabled: var(--zui-color-gs-30);
  --zui-color-checkbox-bg-default-hover: var(--zui-color-gs-40);
  --zui-color-checkbox-bg-default-pressed: var(--zui-color-gs-50);

  --zui-color-checkbox-bg-active-enabled: var(--zui-color-gs-80);
  --zui-color-checkbox-bg-active-disabled: var(--zui-color-gs-80);
  --zui-color-checkbox-bg-active-hover: var(--zui-color-gs-70);
  --zui-color-checkbox-bg-active-pressed: var(--zui-color-gs-90);

  --zui-color-checkbox-border-default-enabled: var(--zui-color-gs-60);
  --zui-color-checkbox-border-default-disabled: var(--zui-color-gs-60);
  --zui-color-checkbox-border-default-hover: var(--zui-color-gs-60);
  --zui-color-checkbox-border-default-pressed: var(--zui-color-gs-60);

  --zui-color-checkbox-border-active-enabled: var(--zui-color-gs-90);
  --zui-color-checkbox-border-active-disabled: var(--zui-color-gs-90);
  --zui-color-checkbox-border-active-hover: var(--zui-color-gs-90);
  --zui-color-checkbox-border-active-pressed: var(--zui-color-gs-90);

  /* Interaction Dialog */
  --zui-color-interaction-dialog-border: var(--zui-color-gs-90);
  --zui-color-interaction-dialog-header-bg-first-hierarchy: var(--zui-color-gs-10);
  --zui-color-interaction-dialog-header-bg-third-hierarchy: var(--zui-color-gs-30);
  --zui-color-interaction-dialog-bg: var(--zui-color-gs-10);
  --zui-color-interaction-dialog-footer-button-border: var(--zui-color-gs-40);

  /* Home-screen Tile */
  --zui-color-home-screen-tile-background-enabled: var(--zui-color-gs-10);
  --zui-color-home-screen-tile-background-hover: var(--zui-color-gs-20);
  --zui-color-home-screen-tile-background-focused: var(--zui-color-gs-10);
  --zui-color-home-screen-tile-background-pressed: var(--zui-color-gs-30);
  --zui-color-home-screen-tile-background-disabled: rgba(var(--zui-color-gs-10-rgb), 0.5);

  --zui-color-home-screen-tile-border-enabled: var(--zui-color-gs-60);
  --zui-color-home-screen-tile-border-hover: var(--zui-color-gs-60);
  --zui-color-home-screen-tile-border-focused: var(--zui-color-gs-60);
  --zui-color-home-screen-tile-border-pressed: var(--zui-color-gs-60);
  --zui-color-home-screen-tile-border-disabled: rgba(var(--zui-color-gs-60-rgb), 0.5);

  --zui-color-home-screen-tile-icon-enabled: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-icon-hover: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-icon-focused: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-icon-pressed: var(--zui-color-gs-100);
  /* icon opacity set separately in home-screen-tile.component.scss to display multicolored icons correctly */
  --zui-color-home-screen-tile-icon-disabled: var(--zui-color-gs-100);

  --zui-color-home-screen-tile-title-enabled: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-title-hover: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-title-focused: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-title-pressed: var(--zui-color-gs-100);
  --zui-color-home-screen-tile-title-disabled: rgba(var(--zui-color-gs-100-rgb), 0.5);

  --zui-color-home-screen-tile-subtitle-enabled: var(--zui-color-gs-85);
  --zui-color-home-screen-tile-subtitle-hover: var(--zui-color-gs-85);
  --zui-color-home-screen-tile-subtitle-focused: var(--zui-color-gs-85);
  --zui-color-home-screen-tile-subtitle-pressed: var(--zui-color-gs-85);
  --zui-color-home-screen-tile-subtitle-disabled: rgba(var(--zui-color-gs-85-rgb), 0.5);
`;

const themeZbdsLight = r$2 `
  ${o$3(bindCssBodyToSelector(themeZbdsBaseRaw, "[theme='zbds-light']"))}
  ${o$3(bindCssBodyToSelector(commonStylesRawStyle$2, "html[theme='zbds-light']"))}
  ${o$3(bindCssBodyToSelector(colorsRawStyle$2, "[theme='zbds-light']"))}
`;

const themeLight = r$2 `
  ${o$3(bindCssBodyToSelector(themeBaseLegacyRaw, "[theme='light']"))}
  ${o$3(bindCssBodyToSelector(commonStylesRawStyle$2, "html[theme='light']"))}
  ${o$3(bindCssBodyToSelector(colorsRawStyle$2, "[theme='light']"))}
`;

const commonStylesRawStyle$1 = cssId `
  background: var(--zui-color-app-bg);
`;

const colorsRawStyle$1 = cssId `
  /* Background Colors */
  --zui-color-app-bg: var(--zui-color-gs-100);

  --zui-color-interactive-element-bg-default-enabled: var(--zui-color-gs-110);
  --zui-color-interactive-element-bg-default-hovered: var(--zui-color-gs-115);
  --zui-color-interactive-element-bg-default-pressed: var(--zui-color-gs-120);
  --zui-color-interactive-element-bg-default-disabled: var(--zui-color-gs-110);

  --zui-color-interactive-element-bg-activated-enabled: var(--zui-color-gs-90);
  --zui-color-interactive-element-bg-activated-hovered: var(--zui-color-gs-95);
  --zui-color-interactive-element-bg-activated-pressed: var(--zui-color-gs-105);
  --zui-color-interactive-element-bg-activated-disabled: var(--zui-color-gs-90);

  --zui-color-interactive-element-bg-primary-enabled: var(--zui-color-pb-100);
  --zui-color-interactive-element-bg-primary-hovered: var(--zui-color-pb-90);
  --zui-color-interactive-element-bg-primary-pressed: var(--zui-color-pb-110);

  --zui-color-first-hierarchy-bg-default-enabled: var(--zui-color-gs-100);
  --zui-color-first-hierarchy-bg-default-hovered: var(--zui-color-gs-105);
  --zui-color-first-hierarchy-bg-default-pressed: var(--zui-color-gs-110);

  --zui-color-first-hierarchy-bg-active-enabled: var(--zui-color-gs-110);
  --zui-color-first-hierarchy-bg-active-hovered: var(--zui-color-gs-115);
  --zui-color-first-hierarchy-bg-active-pressed: var(--zui-color-gs-120);

  --zui-color-first-hierarchy-bg-active-primary-enabled: var(--zui-color-pb-100);
  --zui-color-first-hierarchy-bg-active-primary-hovered: var(--zui-color-pb-90);
  --zui-color-first-hierarchy-bg-active-primary-pressed: var(--zui-color-pb-110);

  --zui-color-second-hierarchy-bg-default-enabled: var(--zui-color-gs-105);
  --zui-color-second-hierarchy-bg-default-hovered: var(--zui-color-gs-110);
  --zui-color-second-hierarchy-bg-default-pressed: var(--zui-color-gs-115);

  --zui-color-second-hierarchy-bg-active-enabled: var(--zui-color-gs-115);
  --zui-color-second-hierarchy-bg-active-hovered: var(--zui-color-gs-120);
  --zui-color-second-hierarchy-bg-active-pressed: var(--zui-color-gs-120);

  --zui-color-second-hierarchy-bg-primary-enabled: var(--zui-color-pb-100);
  --zui-color-second-hierarchy-bg-primary-hovered: var(--zui-color-pb-90);
  --zui-color-second-hierarchy-bg-primary-pressed: var(--zui-color-pb-110);

  --zui-color-third-hierarchy-bg-default-enabled: var(--zui-color-gs-110);
  --zui-color-third-hierarchy-bg-default-hovered: var(--zui-color-gs-115);
  --zui-color-third-hierarchy-bg-default-pressed: var(--zui-color-gs-120);

  --zui-color-third-hierarchy-bg-default-primary-enabled: var(--zui-color-gs-110);
  --zui-color-third-hierarchy-bg-default-primary-hovered: var(--zui-color-gs-115);
  --zui-color-third-hierarchy-bg-default-primary-pressed: var(--zui-color-gs-120);

  --zui-color-third-hierarchy-bg-active-enabled: var(--zui-color-gs-120);
  --zui-color-third-hierarchy-bg-active-hovered: var(--zui-color-gs-120);
  --zui-color-third-hierarchy-bg-active-pressed: var(--zui-color-gs-120);

  --zui-color-fourth-hierarchy-bg-default-enabled: var(--zui-color-gs-115);
  --zui-color-fourth-hierarchy-bg-default-hovered: var(--zui-color-gs-120);
  --zui-color-fourth-hierarchy-bg-default-pressed: var(--zui-color-gs-120);

  --zui-color-text-box-bg: var(--zui-color-gs-110);

  /* Selection colors */
  --zui-color-selection-background: rgba(var(--zui-color-ac-db-110-rgb), var(--zui-selection-opacity));

  /* Dialog Box colors */
  --zui-color-dialog-box-button-bg-focused: var(--zui-color-gs-100);

  --zui-color-dialog-box-top-line: var(--zui-color-gs-90);

  --zui-color-dialog-box-separator-line: var(--zui-color-gs-110);

  /* Dialog Button colors */
  --zui-color-dialog-button-default: var(--zui-color-gs-50);

  /* ewi colors */
  --zui-color-ewi-warning: var(--zui-color-sc-y-100);
  --zui-color-ewi-info: var(--zui-color-pb-90);
  --zui-color-ewi-error: var(--zui-color-sc-r-100);
  --zui-color-ewi-question: var(--zui-color-gs-80);
  --zui-color-ewi-check: var(--zui-color-sc-g-110);

  /* Thumbnail colors */
  /* without header */
  --zui-color-thumbnail-no-header-first-hierarchy-bg-enabled: var(--zui-color-second-hierarchy-bg-default-enabled);
  --zui-color-thumbnail-no-header-first-hierarchy-bg-hovered: var(--zui-color-second-hierarchy-bg-default-hovered);
  --zui-color-thumbnail-no-header-first-hierarchy-bg-pressed: var(--zui-color-second-hierarchy-bg-default-pressed);

  --zui-color-thumbnail-no-header-second-hierarchy-bg-enabled: var(--zui-color-first-hierarchy-bg-default-enabled);
  --zui-color-thumbnail-no-header-second-hierarchy-bg-hovered: var(--zui-color-first-hierarchy-bg-default-hovered);
  --zui-color-thumbnail-no-header-second-hierarchy-bg-pressed: var(--zui-color-first-hierarchy-bg-default-pressed);

  --zui-color-thumbnail-no-header-third-hierarchy-bg-enabled: var(--zui-color-first-hierarchy-bg-default-enabled);
  --zui-color-thumbnail-no-header-third-hierarchy-bg-hovered: var(--zui-color-first-hierarchy-bg-default-hovered);
  --zui-color-thumbnail-no-header-third-hierarchy-bg-pressed: var(--zui-color-first-hierarchy-bg-default-pressed);

  /* with header */
  /* styles for header and border */
  --zui-color-thumbnail-header-first-hierarchy-bg-default-border-header-enabled: var(
    --zui-color-third-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-border-header-hovered: var(
    --zui-color-third-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-border-header-pressed: var(
    --zui-color-third-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-second-hierarchy-bg-default-border-header-enabled: var(
    --zui-color-first-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-border-header-hovered: var(
    --zui-color-first-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-border-header-pressed: var(
    --zui-color-first-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-third-hierarchy-bg-default-border-header-enabled: var(
    --zui-color-first-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-third-hierarchy-bg-default-border-header-hovered: var(
    --zui-color-first-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-third-hierarchy-bg-default-border-header-pressed: var(
    --zui-color-first-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-border-header-enabled: var(
    --zui-color-interactive-element-bg-activated-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-border-header-hovered: var(
    --zui-color-interactive-element-bg-activated-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-border-header-pressed: var(
    --zui-color-interactive-element-bg-activated-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-border-header-enabled: var(
    --zui-color-interactive-element-bg-primary-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-border-header-hovered: var(
    --zui-color-interactive-element-bg-primary-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-border-header-pressed: var(
    --zui-color-interactive-element-bg-primary-pressed
  );

  /* styles for image background */
  --zui-color-thumbnail-header-first-hierarchy-bg-default-image-enabled: var(
    --zui-color-second-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-image-hovered: var(
    --zui-color-second-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-first-hierarchy-bg-default-image-pressed: var(
    --zui-color-second-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-second-hierarchy-bg-default-image-enabled: var(
    --zui-color-third-hierarchy-bg-default-enabled
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-image-hovered: var(
    --zui-color-third-hierarchy-bg-default-hovered
  );
  --zui-color-thumbnail-header-second-hierarchy-bg-default-image-pressed: var(
    --zui-color-third-hierarchy-bg-default-pressed
  );

  --zui-color-thumbnail-header-third-hierarchy-bg-default-image-enabled: var(--zui-color-gs-120);
  --zui-color-thumbnail-header-third-hierarchy-bg-default-image-hovered: var(--zui-color-gs-120);
  --zui-color-thumbnail-header-third-hierarchy-bg-default-image-pressed: var(--zui-color-gs-120);

  --zui-color-thumbnail-header-any-hierarchy-bg-active-image-enabled: var(
    --zui-color-second-hierarchy-bg-active-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-image-hovered: var(
    --zui-color-second-hierarchy-bg-active-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-image-pressed: var(
    --zui-color-second-hierarchy-bg-active-pressed
  );

  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-image-enabled: var(
    --zui-color-second-hierarchy-bg-active-enabled
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-image-hovered: var(
    --zui-color-second-hierarchy-bg-active-hovered
  );
  --zui-color-thumbnail-header-any-hierarchy-bg-active-primary-image-pressed: var(
    --zui-color-second-hierarchy-bg-active-pressed
  );

  /* styles for icon placeholder */
  --zui-color-thumbnail-placeholder-icon: var(--zui-color-gs-80);

  /* Text Colors */
  --zui-color-text-avatar: var(--zui-color-gs-10);
  --zui-color-text-default: var(--zui-color-gs-50);
  --zui-color-text-menu-bar-default-primary: var(--zui-color-gs-50);
  --zui-color-text-on-dark-bg: var(--zui-color-gs-10);
  --zui-color-text-divider: var(--zui-color-gs-70);
  --zui-color-text-primary: var(--zui-color-pb-70);
  --zui-color-text-header: var(--zui-color-gs-10);
  --zui-color-text-secondary-line: var(--zui-color-gs-70);
  --zui-color-text-disabled: var(--zui-color-gs-50);

  /* Input Placeholder Colors */
  --zui-color-placeholder-input: var(--zui-color-gs-80);

  /* Input Bottom Line Colors */
  --zui-color-input-bottom-line-default-enabled: var(--zui-color-gs-120);
  --zui-color-input-bottom-line-default-hover: var(--zui-color-gs-120);
  --zui-color-input-bottom-line-default-focused: var(--zui-color-gs-120);
  --zui-color-input-bottom-line-default-pressed: var(--zui-color-gs-120);

  /* Textarea/Comment Colors */
  --zui-color-textarea-placeholder: var(--zui-color-gs-80);
  --zui-color-textarea-bottom-line: var(--zui-color-gs-120);
  --zui-color-textarea-bottom-line-hover: var(--zui-color-gs-120);

  /* Icon Colors */
  --zui-color-icon-foreground-default: var(--zui-color-gs-110);
  --zui-color-icon-foreground-warning: var(--zui-color-gs-110);

  --zui-color-icon-background-default: currentColor;

  --zui-color-icon-interactive-bg-default-enabled: var(--zui-color-gs-50);
  --zui-color-icon-interactive-bg-default-hovered: var(--zui-color-gs-80);
  --zui-color-icon-interactive-bg-default-pressed: var(--zui-color-gs-70);

  --zui-color-icon-interactive-bg-subtle-enabled: var(--zui-color-gs-70);
  --zui-color-icon-interactive-bg-subtle-hovered: var(--zui-color-gs-90);
  --zui-color-icon-interactive-bg-subtle-pressed: var(--zui-color-gs-85);

  --zui-color-icon-interactive-bg-highlight-enabled: var(--zui-color-gs-10);
  --zui-color-icon-interactive-bg-highlight-hovered: var(--zui-color-gs-70);
  --zui-color-icon-interactive-bg-highlight-pressed: var(--zui-color-gs-60);

  /* Highlight Colors */
  --zui-color-help: var(--zui-color-gs-80);
  --zui-color-info: var(--zui-color-pb-90);
  --zui-color-success: var(--zui-color-sc-g-110);
  --zui-color-warning: var(--zui-color-sc-y-100);
  --zui-color-error: var(--zui-color-sc-r-90);

  /* Line Colors */
  --zui-color-thin-line-default: var(--zui-color-gs-110);
  --zui-color-thin-line-highlight: var(--zui-color-gs-120);
  --zui-color-thick-line-default: var(--zui-color-gs-110);
  --zui-color-thick-line-highlight: var(--zui-color-gs-120);
  --zui-color-thick-line-primary: var(--zui-color-pb-90);

  --zui-color-interactive-element-thin-line-default-enabled: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-default-hovered: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-default-pressed: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-default-disabled: var(--zui-color-gs-120);

  --zui-color-interactive-element-thin-line-activated-enabled: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-activated-hovered: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-activated-pressed: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-activated-disabled: var(--zui-color-gs-120);

  --zui-color-interactive-element-thin-line-primary-enabled: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-primary-hovered: var(--zui-color-gs-120);
  --zui-color-interactive-element-thin-line-primary-pressed: var(--zui-color-gs-120);

  --zui-color-item-separator-line-first-hierarchy-default-enabled: var(--zui-color-gs-105);
  --zui-color-item-separator-line-first-hierarchy-default-hovered: var(--zui-color-gs-105);
  --zui-color-item-separator-line-first-hierarchy-default-focused: var(--zui-color-gs-80);
  --zui-color-item-separator-line-first-hierarchy-default-pressed: var(--zui-color-gs-105);

  --zui-color-item-separator-line-first-hierarchy-active-enabled: var(--zui-color-gs-105);
  --zui-color-item-separator-line-first-hierarchy-active-hovered: var(--zui-color-gs-105);
  --zui-color-item-separator-line-first-hierarchy-active-focused: var(--zui-color-gs-80);
  --zui-color-item-separator-line-first-hierarchy-active-pressed: var(--zui-color-gs-105);

  --zui-color-item-separator-line-first-hierarchy-primary-enabled: var(--zui-color-gs-115);
  --zui-color-item-separator-line-first-hierarchy-primary-hovered: var(--zui-color-gs-115);
  --zui-color-item-separator-line-first-hierarchy-primary-focused: var(--zui-color-gs-10);
  --zui-color-item-separator-line-first-hierarchy-primary-pressed: var(--zui-color-gs-115);

  --zui-color-item-separator-line-second-hierarchy-default-enabled: var(--zui-color-gs-115);
  --zui-color-item-separator-line-second-hierarchy-default-hovered: var(--zui-color-gs-115);
  --zui-color-item-separator-line-second-hierarchy-default-focused: var(--zui-color-gs-80);
  --zui-color-item-separator-line-second-hierarchy-default-pressed: var(--zui-color-gs-115);

  --zui-color-item-separator-line-second-hierarchy-active-enabled: var(--zui-color-gs-115);
  --zui-color-item-separator-line-second-hierarchy-active-hovered: var(--zui-color-gs-115);
  --zui-color-item-separator-line-second-hierarchy-active-focused: var(--zui-color-gs-80);
  --zui-color-item-separator-line-second-hierarchy-active-pressed: var(--zui-color-gs-115);

  --zui-color-item-separator-line-second-hierarchy-primary-enabled: var(--zui-color-gs-115);
  --zui-color-item-separator-line-second-hierarchy-primary-hovered: var(--zui-color-gs-115);
  --zui-color-item-separator-line-second-hierarchy-primary-focused: var(--zui-color-gs-10);
  --zui-color-item-separator-line-second-hierarchy-primary-pressed: var(--zui-color-gs-115);

  --zui-color-tooltip-border: var(--zui-color-gs-120);

  /* State Display */
  --zui-color-interactive-element-state-icon-outline-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-hovered: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-pressed: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-disabled: var(--zui-color-gs-10);

  --zui-color-interactive-element-state-icon-filled-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-filled-hovered: var(--zui-color-gs-50);
  --zui-color-interactive-element-state-icon-filled-pressed: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-filled-disabled: var(--zui-color-gs-10);

  /* Shadow Colors*/
  --zui-color-box-shadow-default: rgba(0, 0, 0, 0.4);

  /* drag-and-drop-area */
  --zui-color-drag-drop-background-first-hierarchy-default-enabled: var(--zui-color-gs-105);
  --zui-color-drag-drop-background-first-hierarchy-default-disabled: var(--zui-color-gs-105);
  --zui-color-drag-drop-background-first-hierarchy-default-hover: var(--zui-color-gs-110);
  --zui-color-drag-drop-background-first-hierarchy-default-pressed: var(--zui-color-gs-115);

  --zui-color-drag-drop-background-second-hierarchy-default-enabled: var(--zui-color-gs-100);
  --zui-color-drag-drop-background-second-hierarchy-default-disabled: var(--zui-color-gs-100);
  --zui-color-drag-drop-background-second-hierarchy-default-hover: var(--zui-color-gs-105);
  --zui-color-drag-drop-background-second-hierarchy-default-pressed: var(--zui-color-gs-110);

  --zui-color-drag-drop-background-first-hierarchy-active: var(--zui-color-gs-105);
  --zui-color-drag-drop-background-second-hierarchy-active: var(--zui-color-gs-100);

  --zui-color-drag-drop-border-default: var(--zui-color-gs-80);
  --zui-color-drag-drop-border-active: var(--zui-color-pb-90);
  --zui-color-drag-drop-font: var(--zui-color-gs-70);
  --zui-color-drag-drop-icon: var(--zui-color-gs-70);

  /* inline-message */
  --zui-color-inline-message-m-l-message-text-without-header: var(--zui-color-gs-50);
  --zui-color-inline-message-m-l-header-text: var(--zui-color-gs-50);
  --zui-color-inline-message-m-l-message-text-with-header: var(--zui-color-gs-70);
  --zui-color-inline-message-s-message-text-without-header: var(--zui-color-gs-70);

  /* radio button */
  --zui-color-radio-button-knob-enabled: var(--zui-color-gs-10);
  --zui-color-radio-button-knob-hovered: var(--zui-color-gs-50);

  --zui-color-radio-button-border-default: var(--zui-color-gs-80);
  --zui-color-radio-button-border-active: var(--zui-color-gs-120);

  /* progress ring component */
  --zui-color-progress-ring-default-background: var(--zui-color-gs-90);
  --zui-color-progress-ring-default-foreground: var(--zui-color-gs-40);
  --zui-color-progress-ring-highlight-background: var(--zui-color-gs-90);
  --zui-color-progress-ring-highlight-foreground: var(--zui-color-pb-90);
  --zui-color-progress-ring-primary-highlight-background: var(--zui-color-gs-10);
  --zui-color-progress-ring-primary-highlight-foreground: var(--zui-color-gs-10);

  --zui-color-progress-ring-default-text: var(--zui-color-gs-50);
  --zui-color-progress-ring-highlight-text: var(--zui-color-gs-50);
  --zui-color-progress-ring-primary-highlight-text: var(--zui-color-gs-10);

  /* progress bar component */
  --zui-color-progress-bar-highlight-background: var(--zui-color-gs-90);
  --zui-color-progress-bar-highlight-foreground: var(--zui-color-gs-40);

  --zui-color-progress-bar-primary-highlight-background: var(--zui-color-gs-90);
  --zui-color-progress-bar-primary-highlight-foreground: var(--zui-color-pb-90);

  --zui-color-progress-bar-striped-background: var(--zui-color-pb-90);
  --zui-color-progress-bar-striped-foreground-left-tile: var(--zui-color-pb-100);
  --zui-color-progress-bar-striped-background-right-tile: var(--zui-color-pb-90);

  /* toast notification component */
  --zui-color-toast-notification-border-color: var(--zui-color-gs-115);
  --zui-color-toast-notification-border-color-inner: var(--zui-color-gs-110);

  /* ewiq dialog component */
  --zui-color-ewiq-dialog-header-text-color: var(--zui-color-gs-10);
  --zui-color-ewiq-dialog-description-text-color: var(--zui-color-gs-70);
  --zui-color-ewiq-dialog-description-safety-text-color: var(--zui-color-gs-50);
  --zui-color-ewiq-dialog-question-text-color: var(--zui-color-gs-50);
  --zui-color-ewiq-dialog-content-text-color: var(--zui-color-gs-50);
  --zui-color-ewiq-dialog-content-background: var(--zui-color-gs-90);

  /* list item component */
  --zui-color-list-item-first-hierarchy-default-enabled: var(--zui-color-gs-100);
  --zui-color-list-item-first-hierarchy-default-hovered: var(--zui-color-gs-105);
  --zui-color-list-item-first-hierarchy-default-focused: var(--zui-color-gs-100);
  --zui-color-list-item-first-hierarchy-default-pressed: var(--zui-color-gs-110);

  --zui-color-list-item-first-hierarchy-active-enabled: var(--zui-color-gs-110);
  --zui-color-list-item-first-hierarchy-active-hovered: var(--zui-color-gs-115);
  --zui-color-list-item-first-hierarchy-active-focused: var(--zui-color-gs-110);
  --zui-color-list-item-first-hierarchy-active-pressed: var(--zui-color-gs-120);

  --zui-color-list-item-first-hierarchy-active-primary-enabled: var(--zui-color-pb-100);
  --zui-color-list-item-first-hierarchy-active-primary-hovered: var(--zui-color-pb-90);
  --zui-color-list-item-first-hierarchy-active-primary-focused: var(--zui-color-pb-100);
  --zui-color-list-item-first-hierarchy-active-primary-pressed: var(--zui-color-pb-110);

  --zui-color-list-item-second-hierarchy-default-enabled: var(--zui-color-gs-105);
  --zui-color-list-item-second-hierarchy-default-hovered: var(--zui-color-gs-110);
  --zui-color-list-item-second-hierarchy-default-focused: var(--zui-color-gs-105);
  --zui-color-list-item-second-hierarchy-default-pressed: var(--zui-color-gs-115);

  --zui-color-list-item-second-hierarchy-active-enabled: var(--zui-color-gs-115);
  --zui-color-list-item-second-hierarchy-active-hovered: var(--zui-color-gs-120);
  --zui-color-list-item-second-hierarchy-active-focused: var(--zui-color-gs-115);
  --zui-color-list-item-second-hierarchy-active-pressed: var(--zui-color-gs-120);

  --zui-color-list-item-second-hierarchy-active-primary-enabled: var(--zui-color-pb-100);
  --zui-color-list-item-second-hierarchy-active-primary-hovered: var(--zui-color-pb-90);
  --zui-color-list-item-second-hierarchy-active-primary-focused: var(--zui-color-pb-100);
  --zui-color-list-item-second-hierarchy-active-primary-pressed: var(--zui-color-pb-110);

  /* scrollbar component */
  --zui-color-scrollbar-track: var(--zui-color-gs-90);
  --zui-color-scrollbar-handle: var(--zui-color-gs-80);
  --zui-color-scrollbar-handle-hover: var(--zui-color-gs-80);

  /* searchbar component */
  --zui-color-searchbar-search-icon: var(--zui-color-gs-70);
  --zui-color-searchbar-input-background: var(--zui-color-gs-115);

  /* select component */
  --zui-color-select-button-watermark: var(--zui-color-gs-80);
  --zui-color-select-button-selected: var(--zui-color-gs-50);
  --zui-color-select-button-readonly: var(--zui-color-gs-50);

  --zui-color-select-arrow-enabled: var(--zui-color-gs-70);
  --zui-color-select-arrow-hovered: var(--zui-color-gs-50);
  --zui-color-select-arrow-focused: var(--zui-color-gs-70);
  --zui-color-select-arrow-pressed: var(--zui-color-gs-50);

  --zui-color-select-bottom-line-watermark-enabled: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-watermark-hovered: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-watermark-focused: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-watermark-pressed: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-selected-enabled: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-selected-hovered: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-selected-focused: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-selected-pressed: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-enabled: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-hovered: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-focused: var(--zui-color-gs-120);
  --zui-color-select-bottom-line-opened-pressed: var(--zui-color-gs-120);

  /* menu component */
  --zui-color-menu-border: var(--zui-color-gs-115);

  --zui-color-menu-item-background-default-enabled: var(--zui-color-second-hierarchy-bg-default-enabled);
  --zui-color-menu-item-background-default-focused: var(--zui-color-second-hierarchy-bg-default-enabled);
  --zui-color-menu-item-background-default-hovered: var(--zui-color-second-hierarchy-bg-default-hovered);
  --zui-color-menu-item-background-default-pressed: var(--zui-color-second-hierarchy-bg-default-pressed);

  --zui-color-menu-item-background-selected-enabled: var(--zui-color-second-hierarchy-bg-active-enabled);
  --zui-color-menu-item-background-selected-focused: var(--zui-color-second-hierarchy-bg-active-enabled);
  --zui-color-menu-item-background-selected-hovered: var(--zui-color-second-hierarchy-bg-active-hovered);
  --zui-color-menu-item-background-selected-pressed: var(--zui-color-second-hierarchy-bg-active-pressed);

  --zui-color-menu-item-background-primary-enabled: var(--zui-color-second-hierarchy-bg-primary-enabled);
  --zui-color-menu-item-background-primary-focused: var(--zui-color-second-hierarchy-bg-primary-enabled);
  --zui-color-menu-item-background-primary-hovered: var(--zui-color-second-hierarchy-bg-primary-hovered);
  --zui-color-menu-item-background-primary-pressed: var(--zui-color-second-hierarchy-bg-primary-pressed);

  --zui-color-menu-more-menu-border-color: var(--zui-color-gs-60);
  --zui-color-menu-more-menu-box-shadow: rgba(0, 0, 0, 0.4);

  /* state dot component */
  --zui-color-state-dot-default: var(--zui-color-gs-110);

  /* state label */
  --zui-color-state-label-background-color-default: var(--zui-color-gs-110);
  --zui-color-state-label-background-color-error: rgba(var(--zui-color-sc-r-100-rgb), 0.2);
  --zui-color-state-label-background-color-progress: rgba(var(--zui-color-pb-90-rgb), 0.2);
  --zui-color-state-label-background-color-ready: rgba(var(--zui-color-sc-g-110-rgb), 0.2);
  --zui-color-state-label-background-color-warning: rgba(var(--zui-color-sc-y-100-rgb), 0.2);
  --zui-color-state-label-text-color-default: var(--zui-color-gs-50);
  --zui-color-state-label-text-color-error: var(--zui-color-sc-r-100);
  --zui-color-state-label-text-color-progress: var(--zui-color-pb-90);
  --zui-color-state-label-text-color-ready: var(--zui-color-sc-g-110);
  --zui-color-state-label-text-color-warning: var(--zui-color-sc-y-110);

  /* pill component */
  --zui-color-pill-background: var(--zui-color-gs-110);
  --zui-color-pill-border: var(--zui-color-gs-120);
  --zui-color-pill-text: var(--zui-color-gs-50);

  /* Slider */

  --zui-color-slider-track-enabled: var(--zui-color-gs-120);
  --zui-color-slider-track-disabled: var(--zui-color-gs-120);
  --zui-color-slider-track-hover: var(--zui-color-gs-120);

  --zui-color-slider-handle-fill-enabled: var(--zui-color-gs-110);
  --zui-color-slider-handle-fill-disabled: var(--zui-color-gs-105);
  --zui-color-slider-handle-fill-disabled-readonly: var(--zui-color-gs-90);
  --zui-color-slider-handle-fill-hover: var(--zui-color-gs-120);

  --zui-color-slider-handle-fill-ghost: var(--zui-color-gs-105);

  --zui-color-slider-handle-border-enabled: var(--zui-color-gs-50);
  --zui-color-slider-handle-border-disabled: var(--zui-color-gs-90);
  --zui-color-slider-handle-border-hover: var(--zui-color-gs-10);

  --zui-color-slider-handle-border-ghost: var(--zui-color-gs-90);

  --zui-color-slider-active-line-enabled: var(--zui-color-gs-50);
  --zui-color-slider-active-line-disabled: var(--zui-color-gs-90);
  --zui-color-slider-active-line-hover: var(--zui-color-gs-50);

  --zui-color-slider-step: var(--zui-color-gs-120);
  --zui-color-slider-tick-label: var(--zui-color-gs-70);

  /** slider readonly **/
  --zui-color-slider-track-readonly-enabled: var(--zui-color-gs-120);
  --zui-color-slider-track-readonly-disabled: var(--zui-color-gs-120);

  --zui-color-slider-handle-fill-readonly-enabled: var(--zui-color-gs-50);
  --zui-color-slider-handle-fill-readonly-disabled: var(--zui-color-gs-90);

  --zui-color-slider-active-line-readonly-enabled: var(--zui-color-gs-50);
  --zui-color-slider-active-line-readonly-disabled: var(--zui-color-gs-90);

  /* date picker component */
  /* grid cell component */
  --zui-color-grid-cell-background-selected: var(--zui-color-gs-80);

  --zui-color-grid-cell-text-default-enabled: var(--zui-color-gs-10);
  --zui-color-grid-cell-text-default-disabled: var(--zui-color-gs-80);
  --zui-color-grid-cell-text-default-hover: var(--zui-color-gs-10);

  --zui-color-grid-cell-text-selected: var(--zui-color-gs-10);

  --zui-color-grid-cell-text-subtle: var(--zui-color-gs-80);

  --zui-color-grid-cell-border-hover: var(--zui-color-gs-80);
  --zui-color-grid-cell-border-pressed: var(--zui-color-gs-60);

  /* user menu button component */
  /* default */
  --zui-color-user-menu-button-user-name-default: var(--zui-color-gs-50);
  --zui-color-user-menu-button-user-role-default: var(--zui-color-gs-70);
  --zui-color-user-menu-button-background-color-default: transparent;

  --zui-color-user-menu-button-user-name-hover-default: var(--zui-color-gs-80);
  --zui-color-user-menu-button-user-role-hover-default: var(--zui-color-gs-90);

  --zui-color-user-menu-button-user-name-focus-default: var(--zui-color-gs-50);
  --zui-color-user-menu-button-user-role-focus-default: var(--zui-color-gs-85);

  --zui-color-user-menu-button-user-name-active-default: var(--zui-color-gs-70);
  --zui-color-user-menu-button-user-role-active-default: var(--zui-color-gs-85);

  /* selected */
  --zui-color-user-menu-button-user-name-selected: var(--zui-color-gs-10);
  --zui-color-user-menu-button-user-role-selected: var(--zui-color-gs-50);
  --zui-color-user-menu-button-background-color-selected: var(--zui-color-gs-120);

  --zui-color-user-menu-button-user-name-hover-selected: var(--zui-color-gs-85);
  --zui-color-user-menu-button-user-role-hover-selected: var(--zui-color-gs-80);

  --zui-color-user-menu-button-user-name-focus-selected: var(--zui-color-gs-10);
  --zui-color-user-menu-button-user-role-focus-selected: var(--zui-color-gs-50);

  --zui-color-user-menu-button-user-name-active-selected: var(--zui-color-gs-60);
  --zui-color-user-menu-button-user-role-active-selected: var(--zui-color-gs-70);

  /* headerbar component */
  --zui-color-headerbar-background: var(--zui-color-gs-100);
  --zui-color-headerbar-button-divider-border-color: var(--zui-color-gs-120);

  /* headerbar icon button component */
  --zui-color-headerbar-icon-button-background-color-selected: var(--zui-color-gs-120);

  /* headerbar product name component */
  --zui-color-headerbar-product-name-color: var(--zui-color-gs-100);
  --zui-color-headerbar-product-sub-name-color: var(--zui-color-gs-85);

  /* searchbar component */
  --zui-color-searchbar-filter-divider: var(--zui-color-gs-120);
  --zui-color-searchbar-query-text: var(--zui-color-gs-50);

  /* picker header text sub component */
  --zui-color-picker-header-text-color-default: var(--zui-color-text-default);
  --zui-color-picker-header-text-color-disabled: var(--zui-color-gs-80);
  --zui-color-picker-header-text-color-hovered: var(--zui-color-gs-10);
  --zui-color-picker-header-text-color-pressed: var(--zui-color-gs-10);
  --zui-color-picker-header-text-color-active: var(--zui-color-gs-10);

  /* list accordion */
  --zui-color-list-accordion-s-closed-header-text-icon: var(--zui-color-gs-80);
  --zui-color-list-accordion-closed-header-text-icon-default: var(--zui-color-gs-50);
  --zui-color-list-accordion-closed-header-text-icon-selected: var(--zui-color-gs-10);
  --zui-color-list-accordion-closed-header-text-icon-selected-primary: var(--zui-color-gs-10);
  --zui-color-list-accordion-open-header-text-icon-default: var(--zui-color-gs-10);
  --zui-color-list-accordion-open-header-text-icon-selected: var(--zui-color-gs-10);
  --zui-color-list-accordion-open-header-text-icon-selected-primary: var(--zui-color-gs-10);

  --zui-color-list-accordion-second-line-text-default: var(--zui-color-gs-70);
  --zui-color-list-accordion-second-line-text-selected: var(--zui-color-gs-70);
  --zui-color-list-accordion-second-line-text-selected-primary: var(--zui-color-gs-50);

  --zui-color-list-accordion-header-background-default-default: var(--zui-color-gs-100);
  --zui-color-list-accordion-header-background-default-hover: var(--zui-color-gs-105);
  --zui-color-list-accordion-header-background-default-focus: var(--zui-color-gs-100);
  --zui-color-list-accordion-header-background-default-active: var(--zui-color-gs-110);

  --zui-color-list-accordion-header-background-selected-default: var(--zui-color-gs-110);
  --zui-color-list-accordion-header-background-selected-hover: var(--zui-color-gs-115);
  --zui-color-list-accordion-header-background-selected-focus: var(--zui-color-gs-110);
  --zui-color-list-accordion-header-background-selected-active: var(--zui-color-gs-120);

  --zui-color-list-accordion-header-background-selected-primary-default: var(--zui-color-pb-100);
  --zui-color-list-accordion-header-background-selected-primary-hover: var(--zui-color-pb-90);
  --zui-color-list-accordion-header-background-selected-primary-focus: var(--zui-color-pb-100);
  --zui-color-list-accordion-header-background-selected-primary-active: var(--zui-color-pb-110);

  --zui-color-list-accordion-header-top-line-default: var(--zui-color-gs-110);
  --zui-color-list-accordion-header-bottom-line-default: var(--zui-color-gs-105);
  --zui-color-list-accordion-header-bottom-line-hover: var(--zui-color-gs-110);
  --zui-color-list-accordion-header-bottom-line-focus: var(--zui-color-gs-80);
  --zui-color-list-accordion-header-bottom-line-active: var(--zui-color-gs-105);

  /* list accordion */
  --zui-color-list-accordion-item-primary-text-default: var(--zui-color-gs-50);
  --zui-color-list-accordion-item-primary-text-selected: var(--zui-color-gs-10);
  --zui-color-list-accordion-item-primary-text-selected-primary: var(--zui-color-gs-10);

  --zui-color-list-accordion-item-background-default: var(--zui-color-list-item-second-hierarchy-default-enabled);
  --zui-color-list-accordion-item-background-selected: var(--zui-color-list-item-second-hierarchy-active-enabled);
  --zui-color-list-accordion-item-background-selected-primary: var(
    --zui-color-list-item-second-hierarchy-active-primary-enabled
  );

  --zui-color-list-accordion-item-border-bottom-default: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-last-default: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-default-hover: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-default-focus: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-default-active: var(--zui-color-gs-115);

  --zui-color-list-accordion-item-border-bottom-selected: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-selected-hover: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-selected-focus: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-selected-active: var(--zui-color-gs-115);

  --zui-color-list-accordion-item-border-bottom-selected-primary: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-selected-primary-hover: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-selected-primary-focus: var(--zui-color-gs-115);
  --zui-color-list-accordion-item-border-bottom-selected-primary-active: var(--zui-color-gs-115);

  --zui-color-list-accordion-item-background-default-hover: var(--zui-color-list-item-second-hierarchy-default-hovered);
  --zui-color-list-accordion-item-background-selected-hover: var(--zui-color-list-item-second-hierarchy-active-hovered);
  --zui-color-list-accordion-item-background-selected-primary-hover: var(
    --zui-color-list-item-second-hierarchy-active-primary-hovered
  );

  --zui-color-list-accordion-item-background-default-focus: var(--zui-color-list-item-second-hierarchy-default-focused);
  --zui-color-list-accordion-item-background-selected-focus: var(--zui-color-list-item-second-hierarchy-active-focused);
  --zui-color-list-accordion-item-background-selected-primary-focus: var(
    --zui-color-list-item-second-hierarchy-active-primary-focused
  );

  --zui-color-list-accordion-item-background-default-active: var(
    --zui-color-list-item-second-hierarchy-default-pressed
  );
  --zui-color-list-accordion-item-background-selected-active: var(
    --zui-color-list-item-second-hierarchy-active-pressed
  );
  --zui-color-list-accordion-item-background-selected-primary-active: var(
    --zui-color-list-item-second-hierarchy-active-primary-pressed
  );

  /* pagination dot */
  --zui-color-pagination-dot-background-default: var(--zui-color-gs-90);
  --zui-color-pagination-dot-background-selected: var(--zui-color-pb-90);

  /* menu tab item */
  --zui-color-menu-tab-item-default-background-active: var(--zui-color-gs-110);
  --zui-color-menu-tab-item-default-background-focus: var(--zui-color-gs-100);
  --zui-color-menu-tab-item-default-background-hover: var(--zui-color-gs-105);
  --zui-color-menu-tab-item-default-background: var(--zui-color-gs-100);
  --zui-color-menu-tab-item-default: var(--zui-color-gs-50);

  --zui-color-menu-tab-item-selected-background: var(--zui-color-gs-100);
  --zui-color-menu-tab-item-selected-border-bottom: var(--zui-color-pb-90);
  --zui-color-menu-tab-item-selected: var(--zui-color-gs-10);

  /* table */
  /* header */
  --zui-color-table-header-first-default-enabled-background: var(--zui-color-gs-110);
  --zui-color-table-header-first-default-enabled-borders: var(--zui-color-gs-120);
  --zui-color-table-header-first-default-enabled-content: var(--zui-color-gs-70);
  --zui-color-table-header-first-default-disabled-background: var(--zui-color-gs-110);
  --zui-color-table-header-first-default-disabled-borders: var(--zui-color-gs-120);
  --zui-color-table-header-first-default-disabled-content: rgba(var(--zui-color-gs-70-rgb), 0.5);
  --zui-color-table-header-first-default-hover-background: var(--zui-color-gs-115);
  --zui-color-table-header-first-default-hover-borders: var(--zui-color-gs-115);
  --zui-color-table-header-first-default-hover-content: var(--zui-color-gs-70);
  --zui-color-table-header-first-default-focused-background: var(--zui-color-gs-110);
  --zui-color-table-header-first-default-focused-borders: var(--zui-color-gs-120);
  --zui-color-table-header-first-default-focused-content: var(--zui-color-gs-70);
  --zui-color-table-header-first-default-pressed-background: var(--zui-color-gs-120);
  --zui-color-table-header-first-default-pressed-borders: var(--zui-color-gs-120);
  --zui-color-table-header-first-default-pressed-content: var(--zui-color-gs-70);

  /* body */
  /* hierarchy - first */
  --zui-color-table-body-first-default-enabled-background: var(--zui-color-gs-100);
  --zui-color-table-body-first-default-enabled-border: var(--zui-color-gs-110);
  --zui-color-table-body-first-default-enabled-content: var(--zui-color-gs-50);
  --zui-color-table-body-first-default-disabled-background: rgba(var(--zui-color-gs-100-rgb), 0.5);
  --zui-color-table-body-first-default-disabled-border: rgba(var(--zui-color-gs-110-rgb), 0.5);
  --zui-color-table-body-first-default-disabled-content: rgba(var(--zui-color-gs-50-rgb), 0.5);
  --zui-color-table-body-first-default-hover-background: var(--zui-color-gs-105);
  --zui-color-table-body-first-default-hover-border: var(--zui-color-gs-110);
  --zui-color-table-body-first-default-hover-content: var(--zui-color-gs-50);
  --zui-color-table-body-first-default-pressed-background: var(--zui-color-gs-110);
  --zui-color-table-body-first-default-pressed-border: var(--zui-color-gs-110);
  --zui-color-table-body-first-default-pressed-content: var(--zui-color-gs-50);
  --zui-color-table-body-first-selected-enabled-background: var(--zui-color-gs-110);
  --zui-color-table-body-first-selected-enabled-border: var(--zui-color-gs-110);
  --zui-color-table-body-first-selected-enabled-content: var(--zui-color-gs-50);
  --zui-color-table-body-first-selected-disabled-background: rgba(var(--zui-color-gs-110-rgb), 0.5);
  --zui-color-table-body-first-selected-disabled-border: rgba(var(--zui-color-gs-110-rgb), 0.5);
  --zui-color-table-body-first-selected-disabled-content: rgba(var(--zui-color-gs-50-rgb), 0.5);
  --zui-color-table-body-first-selected-hover-background: var(--zui-color-gs-115);
  --zui-color-table-body-first-selected-hover-border: var(--zui-color-gs-110);
  --zui-color-table-body-first-selected-hover-content: var(--zui-color-gs-50);
  --zui-color-table-body-first-selected-pressed-background: var(--zui-color-gs-120);
  --zui-color-table-body-first-selected-pressed-border: var(--zui-color-gs-110);
  --zui-color-table-body-first-selected-pressed-content: var(--zui-color-gs-50);

  /* hierarchy - second */
  --zui-color-table-body-second-default-enabled-background: var(--zui-color-gs-105);
  --zui-color-table-body-second-default-enabled-border: var(--zui-color-gs-120);
  --zui-color-table-body-second-default-enabled-content: var(--zui-color-gs-50);
  --zui-color-table-body-second-default-disabled-background: rgba(var(--zui-color-gs-105-rgb), 0.5);
  --zui-color-table-body-second-default-disabled-border: rgba(var(--zui-color-gs-120-rgb), 0.5);
  --zui-color-table-body-second-default-disabled-content: rgba(var(--zui-color-gs-50-rgb), 0.5);
  --zui-color-table-body-second-default-hover-background: var(--zui-color-gs-110);
  --zui-color-table-body-second-default-hover-border: var(--zui-color-gs-120);
  --zui-color-table-body-second-default-hover-content: var(--zui-color-gs-50);
  --zui-color-table-body-second-default-pressed-background: var(--zui-color-gs-115);
  --zui-color-table-body-second-default-pressed-border: var(--zui-color-gs-120);
  --zui-color-table-body-second-default-pressed-content: var(--zui-color-gs-50);
  --zui-color-table-body-second-selected-enabled-background: var(--zui-color-gs-115);
  --zui-color-table-body-second-selected-enabled-border: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-enabled-content: var(--zui-color-gs-50);
  --zui-color-table-body-second-selected-disabled-background: rgba(var(--zui-color-gs-115-rgb), 0.5);
  --zui-color-table-body-second-selected-disabled-border: rgba(var(--zui-color-gs-120-rgb), 0.5);
  --zui-color-table-body-second-selected-disabled-content: rgba(var(--zui-color-gs-50-rgb), 0.5);
  --zui-color-table-body-second-selected-hover-background: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-hover-border: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-hover-content: var(--zui-color-gs-50);
  --zui-color-table-body-second-selected-pressed-background: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-pressed-border: var(--zui-color-gs-120);
  --zui-color-table-body-second-selected-pressed-content: var(--zui-color-gs-50);

  /* title stack */
  --zui-color-title-stack-label: var(--zui-color-gs-70);
  --zui-color-title-stack-headline: var(--zui-color-gs-50);
  --zui-color-title-stack-separator: var(--zui-color-gs-90);
  --zui-color-title-stack-meta: var(--zui-color-gs-70);

  /* toggle switch */
  --zui-color-toggle-switch-default-background-color: var(--zui-color-gs-110);
  --zui-color-toggle-switch-default-background-color-disabled: var(--zui-color-gs-110);
  --zui-color-toggle-switch-default-background-color-hover: var(--zui-color-gs-115);
  --zui-color-toggle-switch-default-background-color-focus: var(--zui-color-gs-110);
  --zui-color-toggle-switch-default-background-color-active: var(--zui-color-gs-120);

  --zui-color-toggle-switch-default-border-color: var(--zui-color-gs-80);
  --zui-color-toggle-switch-default-border-color-disabled: var(--zui-color-gs-80);

  --zui-color-toggle-switch-default-checked-background-color: var(--zui-color-gs-90);
  --zui-color-toggle-switch-default-checked-background-color-disabled: var(--zui-color-gs-90);
  --zui-color-toggle-switch-default-checked-background-color-hover: var(--zui-color-gs-95);
  --zui-color-toggle-switch-default-checked-background-color-focus: var(--zui-color-gs-90);
  --zui-color-toggle-switch-default-checked-background-color-active: var(--zui-color-gs-105);

  --zui-color-toggle-switch-default-checked-border-color: var(--zui-color-gs-120);
  --zui-color-toggle-switch-default-checked-border-color-disabled: var(--zui-color-gs-120);

  --zui-color-toggle-switch-primary-checked-background-color: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-disabled: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-hover: var(--zui-color-pb-90);
  --zui-color-toggle-switch-primary-checked-background-color-focus: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-active: var(--zui-color-pb-110);

  --zui-color-toggle-switch-primary-checked-border-color: var(--zui-color-gs-120);
  --zui-color-toggle-switch-primary-checked-border-color-disabled: var(--zui-color-gs-120);

  /* about screen */
  --zui-color-about-screen-header-background-color-default: var(--zui-color-gs-20);
  --zui-color-about-screen-content-background-color-default: var(--zui-color-gs-10);
  --zui-color-about-screen-footer-background-color-default: var(--zui-color-gs-10);

  --zui-color-about-screen-header-background-color-inverted: var(--zui-color-gs-10);
  --zui-color-about-screen-content-background-color-inverted: var(--zui-color-gs-20);
  --zui-color-about-screen-footer-background-color-inverted: var(--zui-color-gs-20);

  --zui-color-about-screen-software-icon-color: var(--zui-color-gs-100);
  --zui-color-about-screen-software-name-color: var(--zui-color-gs-100);
  --zui-color-about-screen-software-version-color: var(--zui-color-gs-85);
  --zui-color-about-screen-copyright-claim-color: var(--zui-color-gs-85);
  --zui-color-about-screen-licence-title-color: var(--zui-color-gs-120);
  --zui-color-about-screen-small-licence-title-color: var(--zui-color-gs-85);

  /* content tab default item */
  /* text color for emphasis: default */
  --zui-content-tab-default-item-default-text-enabled: var(--zui-color-gs-80);
  --zui-content-tab-default-item-default-text-disabled: var(--zui-color-gs-70);
  --zui-content-tab-default-item-default-text-hovered: var(--zui-color-gs-50);
  --zui-content-tab-default-item-default-text-focused: var(--zui-color-gs-50);
  --zui-content-tab-default-item-default-text-pressed: var(--zui-color-gs-50);

  /* text color for emphasis: selected */
  --zui-content-tab-default-item-selected-text-enabled: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-text-disabled: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-text-hovered: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-text-focused: var(--zui-color-gs-10);
  --zui-content-tab-default-item-selected-text-pressed: var(--zui-color-gs-10);

  /* background for emphasis: default */
  --zui-content-tab-default-item-default-background-enabled: var(--zui-color-gs-110);
  --zui-content-tab-default-item-default-background-disabled: var(--zui-color-gs-110);
  --zui-content-tab-default-item-default-background-hovered: var(--zui-color-gs-115);
  --zui-content-tab-default-item-default-background-focused: var(--zui-color-gs-120);
  --zui-content-tab-default-item-default-background-pressed: var(--zui-color-gs-120);

  /* background for emphasis: selected and hierarchy level: 1 */
  --zui-content-tab-default-item-selected-1-background-enabled: var(--zui-color-gs-100);
  --zui-content-tab-default-item-selected-1-background-disabled: var(--zui-color-gs-100);
  --zui-content-tab-default-item-selected-1-background-hovered: var(--zui-color-gs-100);
  --zui-content-tab-default-item-selected-1-background-focused: var(--zui-color-gs-100);
  --zui-content-tab-default-item-selected-1-background-pressed: var(--zui-color-gs-100);

  /* background for emphasis: selected and hierarchy level: 2 */
  --zui-content-tab-default-item-selected-2-background-enabled: var(--zui-color-gs-105);
  --zui-content-tab-default-item-selected-2-background-disabled: var(--zui-color-gs-105);
  --zui-content-tab-default-item-selected-2-background-hovered: var(--zui-color-gs-105);
  --zui-content-tab-default-item-selected-2-background-focused: var(--zui-color-gs-105);
  --zui-content-tab-default-item-selected-2-background-pressed: var(--zui-color-gs-105);

  /* content tab highlight item */
  /* text color for emphasis: default */
  --zui-content-tab-highlight-item-default-text-enabled: var(--zui-color-gs-50);
  --zui-content-tab-highlight-item-default-text-disabled: var(--zui-color-gs-50);
  --zui-content-tab-highlight-item-default-text-hovered: var(--zui-color-gs-50);
  --zui-content-tab-highlight-item-default-text-focused: var(--zui-color-gs-50);
  --zui-content-tab-highlight-item-default-text-pressed: var(--zui-color-gs-50);

  /* text color for emphasis: selected */
  --zui-content-tab-highlight-item-selected-text-enabled: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-text-disabled: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-text-hovered: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-text-focused: var(--zui-color-gs-10);
  --zui-content-tab-highlight-item-selected-text-pressed: var(--zui-color-gs-10);

  /* background for emphasis: default */
  --zui-content-tab-highlight-item-default-background-enabled: var(--zui-color-gs-110);
  --zui-content-tab-highlight-item-default-background-disabled: var(--zui-color-gs-110);
  --zui-content-tab-highlight-item-default-background-hovered: var(--zui-color-gs-115);
  --zui-content-tab-highlight-item-default-background-focused: var(--zui-color-gs-120);
  --zui-content-tab-highlight-item-default-background-pressed: var(--zui-color-gs-120);

  /* background for emphasis: selected and hierarchy level: 1 */
  --zui-content-tab-highlight-item-selected-1-background-enabled: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-selected-1-background-disabled: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-selected-1-background-hovered: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-selected-1-background-focused: var(--zui-color-gs-100);
  --zui-content-tab-highlight-item-selected-1-background-pressed: var(--zui-color-gs-100);

  /* background for emphasis: selected and hierarchy level: 2 */
  --zui-content-tab-highlight-item-selected-2-background-enabled: var(--zui-color-gs-105);
  --zui-content-tab-highlight-item-selected-2-background-disabled: var(--zui-color-gs-105);
  --zui-content-tab-highlight-item-selected-2-background-hovered: var(--zui-color-gs-105);
  --zui-content-tab-highlight-item-selected-2-background-focused: var(--zui-color-gs-105);
  --zui-content-tab-highlight-item-selected-2-background-pressed: var(--zui-color-gs-105);

  /* border-top */
  --zui-content-tab-highlight-item-selected-border: var(--zui-color-pb-90);

  /* content tab image item */
  /* text color for emphasis: default */
  --zui-content-tab-image-item-default-text-enabled: var(--zui-color-gs-80);
  --zui-content-tab-image-item-default-text-disabled: var(--zui-color-gs-80);
  --zui-content-tab-image-item-default-text-hovered: var(--zui-color-gs-50);
  --zui-content-tab-image-item-default-text-focused: var(--zui-color-gs-80);
  --zui-content-tab-image-item-default-text-pressed: var(--zui-color-gs-10);

  /* background for emphasis: default */
  --zui-content-tab-image-item-default-background-enabled: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-disabled: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-hovered: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-focused: var(--zui-color-gs-115);
  --zui-content-tab-image-item-default-background-pressed: var(--zui-color-gs-115);

  /* text color for emphasis: selected */
  --zui-content-tab-image-item-selected-text-enabled: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-disabled: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-hovered: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-focused: var(--zui-color-gs-10);
  --zui-content-tab-image-item-selected-text-pressed: var(--zui-color-gs-10);

  /* background for emphasis: selected */
  --zui-content-tab-image-item-selected-background-enabled: var(--zui-color-gs-110);
  --zui-content-tab-image-item-selected-background-disabled: var(--zui-color-gs-110);
  --zui-content-tab-image-item-selected-background-hovered: var(--zui-color-gs-110);
  --zui-content-tab-image-item-selected-background-focused: var(--zui-color-gs-110);
  --zui-content-tab-image-item-selected-background-pressed: var(--zui-color-gs-110);

  /* content tab bar */
  --zui-content-tab-bar-rectangle-background: var(--zui-color-gs-110);

  /* color override for the close icon (always dark mode) */
  /* emphasis component: default = emphasis icon: muted */
  --zui-content-tab-image-item-interactive-item-default-enabled: var(--zui-color-gs-80);
  --zui-content-tab-image-item-interactive-item-default-hovered: var(--zui-color-gs-90);
  --zui-content-tab-image-item-interactive-item-default-pressed: var(--zui-color-gs-70);

  /* emphasis component: selected = emphasis icon: highlight */
  --zui-content-tab-image-item-interactive-item-selected-enabled: var(--zui-color-gs-10);
  --zui-content-tab-image-item-interactive-item-selected-hovered: var(--zui-color-gs-70);
  --zui-content-tab-image-item-interactive-item-selected-pressed: var(--zui-color-gs-60);

  /* step indicator item */
  --zui-step-indicator-item-text-color-next: var(--zui-color-gs-80);
  --zui-step-indicator-item-text-color-selected: var(--zui-color-gs-10);
  --zui-step-indicator-item-text-color-visited: var(--zui-color-gs-80);

  --zui-step-indicator-item-border-color-next: var(--zui-color-gs-80);
  --zui-step-indicator-item-border-color-selected: var(--zui-color-pb-90);
  --zui-step-indicator-item-border-color-visited: var(--zui-color-ac-db-110);

  /* focus view bar */
  --zui-focus-view-bar-background-color: var(--zui-color-gs-100);

  /* tag component */
  --zui-color-tag-background-enabled: var(--zui-color-gs-110);
  --zui-color-tag-background-hovered: var(--zui-color-gs-115);
  --zui-color-tag-background-active: var(--zui-color-gs-120);
  --zui-color-tag-border: var(--zui-color-gs-120);
  --zui-color-tag-text: var(--zui-color-gs-50);

  /* interactive text */
  --zui-color-interactive-text-default-enabled: var(--zui-color-gs-50);
  --zui-color-interactive-text-default-hovered: var(--zui-color-gs-80);
  --zui-color-interactive-text-default-focused: var(--zui-color-gs-50);
  --zui-color-interactive-text-default-pressed: var(--zui-color-gs-70);

  --zui-color-interactive-text-subtle-enabled: var(--zui-color-gs-70);
  --zui-color-interactive-text-subtle-hovered: var(--zui-color-gs-90);
  --zui-color-interactive-text-subtle-focused: var(--zui-color-gs-70);
  --zui-color-interactive-text-subtle-pressed: var(--zui-color-gs-85);

  --zui-color-interactive-text-highlight-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-text-highlight-hovered: var(--zui-color-gs-70);
  --zui-color-interactive-text-highlight-focused: var(--zui-color-gs-10);
  --zui-color-interactive-text-highlight-pressed: var(--zui-color-gs-60);

  --zui-color-interactive-text-primary-highlight-enabled: var(--zui-color-pb-90);
  --zui-color-interactive-text-primary-highlight-hovered: var(--zui-color-pb-70);
  --zui-color-interactive-text-primary-highlight-focused: var(--zui-color-pb-90);
  --zui-color-interactive-text-primary-highlight-pressed: var(--zui-color-pb-80);

  /* quiet link */
  --zui-color-quiet-link-default-enabled: var(--zui-color-gs-50);
  --zui-color-quiet-link-default-hovered: var(--zui-color-gs-80);
  --zui-color-quiet-link-default-focused: var(--zui-color-gs-50);
  --zui-color-quiet-link-default-active: var(--zui-color-gs-70);
  --zui-color-quiet-link-default-visited: var(--zui-color-gs-50);

  --zui-color-quiet-link-subtle-enabled: var(--zui-color-gs-70);
  --zui-color-quiet-link-subtle-hovered: var(--zui-color-gs-90);
  --zui-color-quiet-link-subtle-focused: var(--zui-color-gs-70);
  --zui-color-quiet-link-subtle-active: var(--zui-color-gs-85);
  --zui-color-quiet-link-subtle-visited: var(--zui-color-gs-70);

  --zui-color-quiet-link-highlight-enabled: var(--zui-color-gs-10);
  --zui-color-quiet-link-highlight-hovered: var(--zui-color-gs-70);
  --zui-color-quiet-link-highlight-focused: var(--zui-color-gs-10);
  --zui-color-quiet-link-highlight-active: var(--zui-color-gs-60);
  --zui-color-quiet-link-highlight-visited: var(--zui-color-gs-10);

  --zui-color-quiet-link-primary-highlight-enabled: var(--zui-color-pb-90);
  --zui-color-quiet-link-primary-highlight-hovered: var(--zui-color-pb-70);
  --zui-color-quiet-link-primary-highlight-focused: var(--zui-color-pb-90);
  --zui-color-quiet-link-primary-highlight-active: var(--zui-color-pb-80);
  --zui-color-quiet-link-primary-highlight-visited: var(--zui-color-pb-90);

  /* time picker input */
  --zui-time-picker-input-border-bottom-disabled-color: rgba(var(--zui-color-gs-120-rgb), var(--zui-disabled-opacity));

  /* time picker cell */
  --zui-time-picker-cell-background-color: var(--zui-color-gs-110);
  --zui-time-picker-cell-background-color-hovered: var(--zui-color-gs-115);
  --zui-time-picker-cell-background-color-focused: var(--zui-color-gs-110);
  --zui-time-picker-cell-background-color-pressed: var(--zui-color-gs-120);

  --zui-time-picker-cell-border-color: var(--zui-color-gs-120);
  --zui-time-picker-cell-border-color-hovered: var(--zui-color-gs-120);
  --zui-time-picker-cell-border-color-focused: var(--zui-color-gs-120);
  --zui-time-picker-cell-border-color-pressed: var(--zui-color-gs-120);

  --zui-time-picker-cell-text-color: var(--zui-color-gs-10);
  --zui-time-picker-cell-text-color-hovered: var(--zui-color-gs-10);
  --zui-time-picker-cell-text-color-focused: var(--zui-color-gs-10);
  --zui-time-picker-cell-text-color-pressed: var(--zui-color-gs-10);

  /* time picker cell divider */
  --zui-time-picker-cell-divider-color: var(--zui-color-gs-50);

  /* content accordion details */
  /* background */
  --zui-content-accordion-details-background: var(--zui-color-gs-100);

  /* bottom line */
  --zui-content-accordion-details-bottom-line-enabled-disabled-hovered-pressed: var(--zui-color-gs-105);
  --zui-content-accordion-details-bottom-line-focused: var(--zui-color-gs-80);

  /* standalone for size s + m + l */
  /* closed */
  --zui-content-accordion-details-standalone-closed-text-icon-enabled: var(--zui-color-gs-70);
  --zui-content-accordion-details-standalone-closed-text-icon-disabled: var(--zui-color-gs-70);
  --zui-content-accordion-details-standalone-closed-text-icon-hovered: var(--zui-color-gs-90);
  --zui-content-accordion-details-standalone-closed-text-icon-focused: var(--zui-color-gs-70);
  --zui-content-accordion-details-standalone-closed-text-icon-pressed: var(--zui-color-gs-85);

  /* open */
  --zui-content-accordion-details-standalone-open-text-icon-enabled: var(--zui-color-gs-10);
  --zui-content-accordion-details-standalone-open-text-icon-disabled: var(--zui-color-gs-10);
  --zui-content-accordion-details-standalone-open-text-icon-hovered: var(--zui-color-gs-70);
  --zui-content-accordion-details-standalone-open-text-icon-focused: var(--zui-color-gs-10);
  --zui-content-accordion-details-standalone-open-text-icon-pressed: var(--zui-color-gs-60);

  /* integrated for size m + s */
  /* closed */
  --zui-content-accordion-details-integrated-s-m-closed-text-enabled: var(--zui-color-gs-50);
  --zui-content-accordion-details-integrated-s-m-closed-text-disabled: var(--zui-color-gs-50);
  --zui-content-accordion-details-integrated-s-m-closed-text-hovered: var(--zui-color-gs-80);
  --zui-content-accordion-details-integrated-s-m-closed-text-focused: var(--zui-color-gs-50);
  --zui-content-accordion-details-integrated-s-m-closed-text-pressed: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-s-m-closed-icon-enabled: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-s-m-closed-icon-disabled: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-s-m-closed-icon-hovered: var(--zui-color-gs-90);
  --zui-content-accordion-details-integrated-s-m-closed-icon-focused: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-s-m-closed-icon-pressed: var(--zui-color-gs-85);
  /* open */
  --zui-content-accordion-details-integrated-s-m-open-text-icon-enabled: var(--zui-color-gs-10);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-disabled: var(--zui-color-gs-10);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-hovered: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-focused: var(--zui-color-gs-10);
  --zui-content-accordion-details-integrated-s-m-open-text-icon-pressed: var(--zui-color-gs-60);

  /* integrated for size l */
  /* closed */
  --zui-content-accordion-details-integrated-l-closed-text-enabled: var(--zui-color-gs-50);
  --zui-content-accordion-details-integrated-l-closed-text-disabled: var(--zui-color-gs-50);
  --zui-content-accordion-details-integrated-l-closed-text-hovered: var(--zui-color-gs-80);
  --zui-content-accordion-details-integrated-l-closed-text-focused: var(--zui-color-gs-50);
  --zui-content-accordion-details-integrated-l-closed-text-pressed: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-l-closed-icon-enabled: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-l-closed-icon-disabled: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-l-closed-icon-hovered: var(--zui-color-gs-90);
  --zui-content-accordion-details-integrated-l-closed-icon-focused: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-l-closed-icon-pressed: var(--zui-color-gs-85);
  /* open */
  --zui-content-accordion-details-integrated-l-open-text-icon-enabled: var(--zui-color-gs-10);
  --zui-content-accordion-details-integrated-l-open-text-icon-disabled: var(--zui-color-gs-10);
  --zui-content-accordion-details-integrated-l-open-text-icon-hovered: var(--zui-color-gs-70);
  --zui-content-accordion-details-integrated-l-open-text-icon-focused: var(--zui-color-gs-10);
  --zui-content-accordion-details-integrated-l-open-text-icon-pressed: var(--zui-color-gs-60);

  /* ~~ Expander ~~ */
  /* background */
  /* hierarchy first */
  --zui-color-expander-bg-first-hierarchy-enabled: var(--zui-color-gs-100);
  --zui-color-expander-bg-first-hierarchy-disabled: var(--zui-color-gs-100);
  --zui-color-expander-bg-first-hierarchy-hover: var(--zui-color-gs-105);
  --zui-color-expander-bg-first-hierarchy-focus: var(--zui-color-gs-100);
  --zui-color-expander-bg-first-hierarchy-active: var(--zui-color-gs-110);
  /* hierarchy second */
  --zui-color-expander-bg-second-hierarchy-enabled: var(--zui-color-gs-105);
  --zui-color-expander-bg-second-hierarchy-disabled: var(--zui-color-gs-105);
  --zui-color-expander-bg-second-hierarchy-hover: var(--zui-color-gs-110);
  --zui-color-expander-bg-second-hierarchy-focus: var(--zui-color-gs-105);
  --zui-color-expander-bg-second-hierarchy-active: var(--zui-color-gs-115);

  /* icon */
  --zui-color-expander-icon-color: var(--zui-color-gs-80);

  /* ~~ Text Link ~~ */
  --zui-color-text-link-subtle-enabled: var(--zui-color-gs-70);
  --zui-color-text-link-subtle-hover: var(--zui-color-gs-90);
  --zui-color-text-link-subtle-focused: var(--zui-color-gs-70);
  --zui-color-text-link-subtle-active: var(--zui-color-gs-85);

  --zui-color-text-link-default-enabled: var(--zui-color-gs-50);
  --zui-color-text-link-default-hover: var(--zui-color-gs-80);
  --zui-color-text-link-default-focused: var(--zui-color-gs-50);
  --zui-color-text-link-default-active: var(--zui-color-gs-70);

  --zui-color-text-link-highlight-enabled: var(--zui-color-gs-10);
  --zui-color-text-link-highlight-hover: var(--zui-color-gs-70);
  --zui-color-text-link-highlight-focused: var(--zui-color-gs-10);
  --zui-color-text-link-highlight-active: var(--zui-color-gs-60);

  --zui-color-text-link-primary-highlight-enabled: var(--zui-color-pb-90);
  --zui-color-text-link-primary-highlight-hover: var(--zui-color-pb-70);
  --zui-color-text-link-primary-highlight-focused: var(--zui-color-pb-90);
  --zui-color-text-link-primary-highlight-active: var(--zui-color-pb-80);

  --zui-color-text-link-visited: var(--zui-color-ac-db-110);

  /* Chat Item */
  /* inbound */
  --zui-color-chat-item-inbound-bg: var(--zui-color-gs-100);
  --zui-color-chat-item-inbound-text: var(--zui-color-gs-50);
  --zui-color-chat-item-inbound-bg-selection: rgba(var(--zui-color-ac-db-110-rgb), 0.4);

  /* outbound */
  --zui-color-chat-item-outbound-bg: var(--zui-color-ac-db-110);
  --zui-color-chat-item-outbound-text: var(--zui-color-gs-10);
  --zui-color-chat-item-outbound-bg-selection: rgba(var(--zui-color-gs-100-rgb), 0.3);

  /* incidentials */
  --zui-color-chat-item-delivery-text: var(--zui-color-gs-70);
  --zui-color-chat-item-delivery-bg-selection: rgba(var(--zui-color-ac-db-110-rgb), 0.3);
  --zui-color-chat-item-divider: var(--zui-color-gs-120);

  /* Multiline Input Field */
  --zui-color-multiline-textfield-border-enabled: var(--zui-color-gs-120);
  --zui-color-multiline-textfield-border-hover: var(--zui-color-gs-120);
  --zui-color-multiline-textfield-border-focused: var(--zui-color-gs-120);
  --zui-color-multiline-textfield-border-pressed: var(--zui-color-gs-120);
  --zui-color-multiline-textfield-border-error: var(--zui-color-sc-r-90);
  --zui-color-multiline-textfield-border-readonly: transparent;
  --zui-color-multiline-textfield-border-disabled: rgba(var(--zui-color-gs-120-rgb), 0.5);

  --zui-color-multiline-textfield-watermark-enabled: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-hover: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-focused: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-pressed: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-error: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-watermark-readonly: transparent;
  --zui-color-multiline-textfield-watermark-disabled: rgba(var(--zui-color-gs-80-rgb), 0.5);

  --zui-color-multiline-textfield-input-enabled: var(--zui-color-gs-50);
  --zui-color-multiline-textfield-input-hover: var(--zui-color-gs-50);
  --zui-color-multiline-textfield-input-focused: var(--zui-color-gs-50);
  --zui-color-multiline-textfield-input-pressed: var(--zui-color-gs-50);
  --zui-color-multiline-textfield-input-error: var(--zui-color-gs-50);
  --zui-color-multiline-textfield-input-readonly: var(--zui-color-gs-50);
  --zui-color-multiline-textfield-input-disabled: rgba(var(--zui-color-gs-50-rgb), 0.5);

  --zui-color-multiline-textfield-limit-indicator-enabled: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-hover: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-focused: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-pressed: var(--zui-color-gs-80);
  --zui-color-multiline-textfield-limit-indicator-error: var(--zui-color-sc-r-90);
  --zui-color-multiline-textfield-limit-indicator-readonly: transparent;
  --zui-color-multiline-textfield-limit-indicator-disabled: rgba(var(--zui-color-gs-80-rgb), 0.5);

  --zui-color-multiline-textfield-text-selection: rgba(var(--zui-color-ac-db-110-rgb), 0.3);

  /* Checkbox */
  --zui-color-checkbox-bg-default-enabled: var(--zui-color-gs-110);
  --zui-color-checkbox-bg-default-disabled: var(--zui-color-gs-110);
  --zui-color-checkbox-bg-default-hover: var(--zui-color-gs-115);
  --zui-color-checkbox-bg-default-pressed: var(--zui-color-gs-120);

  --zui-color-checkbox-bg-active-enabled: var(--zui-color-gs-90);
  --zui-color-checkbox-bg-active-disabled: var(--zui-color-gs-90);
  --zui-color-checkbox-bg-active-hover: var(--zui-color-gs-95);
  --zui-color-checkbox-bg-active-pressed: var(--zui-color-gs-105);

  --zui-color-checkbox-border-default-enabled: var(--zui-color-gs-80);
  --zui-color-checkbox-border-default-disabled: var(--zui-color-gs-80);
  --zui-color-checkbox-border-default-hover: var(--zui-color-gs-80);
  --zui-color-checkbox-border-default-pressed: var(--zui-color-gs-80);

  --zui-color-checkbox-border-active-enabled: var(--zui-color-gs-120);
  --zui-color-checkbox-border-active-disabled: var(--zui-color-gs-120);
  --zui-color-checkbox-border-active-hover: var(--zui-color-gs-120);
  --zui-color-checkbox-border-active-pressed: var(--zui-color-gs-120);

  /* Interaction Dialog */
  --zui-color-interaction-dialog-border: var(--zui-color-gs-90);
  --zui-color-interaction-dialog-header-bg-first-hierarchy: var(--zui-color-gs-100);
  --zui-color-interaction-dialog-header-bg-third-hierarchy: var(--zui-color-gs-110);
  --zui-color-interaction-dialog-bg: var(--zui-color-gs-100);
  --zui-color-interaction-dialog-footer-button-border: var(--zui-color-gs-110);

  /* Home-screen Tile */
  --zui-color-home-screen-tile-background-enabled: var(--zui-color-gs-105);
  --zui-color-home-screen-tile-background-hover: var(--zui-color-gs-110);
  --zui-color-home-screen-tile-background-focused: var(--zui-color-gs-105);
  --zui-color-home-screen-tile-background-pressed: var(--zui-color-gs-115);
  --zui-color-home-screen-tile-background-disabled: rgba(var(--zui-color-gs-105-rgb), 0.5);

  --zui-color-home-screen-tile-border-enabled: var(--zui-color-gs-120);
  --zui-color-home-screen-tile-border-hover: var(--zui-color-gs-120);
  --zui-color-home-screen-tile-border-focused: var(--zui-color-gs-120);
  --zui-color-home-screen-tile-border-pressed: var(--zui-color-gs-120);
  --zui-color-home-screen-tile-border-disabled: rgba(var(--zui-color-gs-120-rgb), 0.5);

  --zui-color-home-screen-tile-icon-enabled: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-icon-hover: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-icon-focused: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-icon-pressed: var(--zui-color-gs-50);
  /* icon opacity set separately in home-screen-tile.component.scss to display multicolored icons correctly */
  --zui-color-home-screen-tile-icon-disabled: var(--zui-color-gs-50);

  --zui-color-home-screen-tile-title-enabled: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-title-hover: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-title-focused: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-title-pressed: var(--zui-color-gs-50);
  --zui-color-home-screen-tile-title-disabled: rgba(var(--zui-color-gs-50-rgb), 0.5);

  --zui-color-home-screen-tile-subtitle-enabled: var(--zui-color-gs-70);
  --zui-color-home-screen-tile-subtitle-hover: var(--zui-color-gs-70);
  --zui-color-home-screen-tile-subtitle-focused: var(--zui-color-gs-70);
  --zui-color-home-screen-tile-subtitle-pressed: var(--zui-color-gs-70);
  --zui-color-home-screen-tile-subtitle-disabled: rgba(var(--zui-color-gs-70-rgb), 0.5);
`;

const themeZbdsDark = r$2 `
  ${o$3(bindCssBodyToSelector(themeZbdsBaseRaw, "[theme='zbds-dark']"))}
  ${o$3(bindCssBodyToSelector(commonStylesRawStyle$1, "html[theme='zbds-dark']"))}
  ${o$3(bindCssBodyToSelector(colorsRawStyle$1, "[theme='zbds-dark']"))}
`;

const themeDark = r$2 `
  ${o$3(bindCssBodyToSelector(themeBaseLegacyRaw, "[theme='dark']"))}
  ${o$3(bindCssBodyToSelector(commonStylesRawStyle$1, "html[theme='dark']"))}
  ${o$3(bindCssBodyToSelector(colorsRawStyle$1, "[theme='dark']"))}
`;

// this is until now a placeholder and for the time being intentionally empty
const commonStylesRawStyle = cssId ``;

const colorsRawStyle = cssId `
  /* toggle switch */
  --zui-color-toggle-switch-default-background-color: rgba(var(--zui-color-gs-10-rgb), 0.1);
  --zui-color-toggle-switch-default-background-color-disabled: rgba(var(--zui-color-gs-10-rgb), 0.05);
  --zui-color-toggle-switch-default-background-color-hover: rgba(var(--zui-color-gs-10-rgb), 0.18);
  --zui-color-toggle-switch-default-background-color-focus: rgba(var(--zui-color-gs-10-rgb), 0.1);
  --zui-color-toggle-switch-default-background-color-active: rgba(var(--zui-color-gs-10-rgb), 0.5);

  --zui-color-toggle-switch-default-border-color: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-toggle-switch-default-border-color-disabled: rgba(var(--zui-color-gs-10-rgb), 0.3);

  --zui-color-toggle-switch-default-checked-background-color: rgba(var(--zui-color-gs-10-rgb), 0.5);
  --zui-color-toggle-switch-default-checked-background-color-disabled: rgba(var(--zui-color-gs-10-rgb), 0.25);
  --zui-color-toggle-switch-default-checked-background-color-hover: rgba(var(--zui-color-gs-10-rgb), 0.55);
  --zui-color-toggle-switch-default-checked-background-color-focus: rgba(var(--zui-color-gs-10-rgb), 0.5);
  --zui-color-toggle-switch-default-checked-background-color-active: rgba(var(--zui-color-gs-10-rgb), 0.6);

  --zui-color-toggle-switch-default-checked-border-color: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-toggle-switch-default-checked-border-color-disabled: rgba(var(--zui-color-gs-10-rgb), 0.15);

  --zui-color-toggle-switch-primary-checked-background-color: var(--zui-color-pb-100);
  /* --zui-color-pb-100 */
  --zui-color-toggle-switch-primary-checked-background-color-disabled: rgba(0, 80, 242, 0.5);
  --zui-color-toggle-switch-primary-checked-background-color-hover: var(--zui-color-pb-90);
  --zui-color-toggle-switch-primary-checked-background-color-focus: var(--zui-color-pb-100);
  --zui-color-toggle-switch-primary-checked-background-color-active: var(--zui-color-pb-80);

  --zui-color-toggle-switch-primary-checked-border-color: var(--zui-color-pb-120);
  /* --zui-color-pb-120 */
  --zui-color-toggle-switch-primary-checked-border-color-disabled: rgba(0, 41, 175, 0.5);

  /* checkbox */
  /* background */
  /* default */
  --zui-color-interactive-element-bg-default-enabled: rgba(var(--zui-color-gs-10-rgb), 0.1);
  --zui-color-interactive-element-bg-default-hovered: rgba(var(--zui-color-gs-10-rgb), 0.18);
  --zui-color-interactive-element-bg-default-pressed: rgba(var(--zui-color-gs-10-rgb), 0.26);
  --zui-color-interactive-element-bg-default-disabled: rgba(var(--zui-color-gs-10-rgb), 0.05);

  /* selected/ mixed */
  --zui-color-interactive-element-bg-activated-enabled: rgba(var(--zui-color-gs-10-rgb), 0.1);
  --zui-color-interactive-element-bg-activated-hovered: rgba(var(--zui-color-gs-10-rgb), 0.18);
  --zui-color-interactive-element-bg-activated-pressed: rgba(var(--zui-color-gs-10-rgb), 0.26);
  --zui-color-interactive-element-bg-activated-disabled: rgba(var(--zui-color-gs-10-rgb), 0.05);

  /* border */
  /* default */
  --zui-color-interactive-element-thin-line-default-enabled: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-interactive-element-thin-line-default-hovered: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-interactive-element-thin-line-default-pressed: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-interactive-element-thin-line-default-disabled: rgba(var(--zui-color-gs-10-rgb), 0.3);

  /* selected/mixed */
  --zui-color-interactive-element-thin-line-activated-enabled: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-interactive-element-thin-line-activated-hovered: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-interactive-element-thin-line-activated-pressed: rgba(var(--zui-color-gs-10-rgb), 0.6);
  --zui-color-interactive-element-thin-line-activated-disabled: rgba(var(--zui-color-gs-10-rgb), 0.3);

  /* text */
  --zui-color-text-default: var(--zui-color-gs-50);
  --zui-color-text-disabled: rgba(var(--zui-color-gs-50-rgb), 0.5);

  /* checkmark */
  --zui-color-interactive-element-state-icon-outline-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-hovered: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-pressed: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-outline-disabled: rgba(var(--zui-color-gs-10-rgb), 0.5);

  /* mixed-square */
  --zui-color-interactive-element-state-icon-filled-enabled: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-filled-hovered: var(--zui-color-gs-50);
  --zui-color-interactive-element-state-icon-filled-pressed: var(--zui-color-gs-10);
  --zui-color-interactive-element-state-icon-filled-disabled: rgba(var(--zui-color-gs-10-rgb), 0.5);

  /* loader box */
  /* background */
  --zui-color-loader-box-bg: rgba(var(--zui-color-gs-120-rgb), 0.85);
  /* headline */
  --zui-color-loader-box-headline-text: var(--zui-color-gs-10);
  /* description */
  --zui-color-loader-box-description-text: var(--zui-color-gs-50);
  --zui-color-loader-box-description-text-with-headline: var(--zui-color-gs-70);
  /* progress ring */
  --zui-color-loader-box-progress-ring-rail: var(--zui-color-gs-90);
  --zui-color-loader-box-progress-ring-progress: var(--zui-color-gs-40);
  --zui-color-loader-box-progress-ring-default-text: var(--zui-color-gs-50);
`;

const themeZbdsTranslucent = r$2 `
  ${o$3(bindCssBodyToSelector(themeZbdsBaseRaw, "[theme='zbds-translucent']"))}
  ${o$3(bindCssBodyToSelector(commonStylesRawStyle, "html[theme='zbds-translucent']"))}
  ${o$3(bindCssBodyToSelector(colorsRawStyle, "[theme='zbds-translucent']"))}
`;

const themeTranslucent = r$2 `
  ${o$3(bindCssBodyToSelector(themeBaseLegacyRaw, "[theme='translucent']"))}
  ${o$3(bindCssBodyToSelector(commonStylesRawStyle, "html[theme='translucent']"))}
  ${o$3(bindCssBodyToSelector(colorsRawStyle, "[theme='translucent']"))}
`;

const segoeUIFontFaces = r$2 `
  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Light');
    font-weight: 200;
    font-style: normal;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Semilight');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI');
    font-weight: 400;
    font-style: normal;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Semibold');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Bold');
    font-weight: 700;
    font-style: normal;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Light Italic');
    font-weight: 200;
    font-style: italic;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Semilight Italic');
    font-weight: 300;
    font-style: italic;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Italic');
    font-weight: 400;
    font-style: italic;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Semibold Italic');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'Segoe UI';
    src: local('Segoe UI Bold Italic');
    font-weight: 700;
    font-style: italic;
  }
`;
const fontFaces = (fontDirectoryURL) => {
    const fontDirectory = o$3(fontDirectoryURL);
    return r$2 `
    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans Light'), local('NotoSans-Light'),
        url('${fontDirectory}/NotoSans-Light.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-Light.woff') format('woff');
      font-weight: 300;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans Regular'), local('NotoSans-Regular'),
        url('${fontDirectory}/NotoSans-Regular.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-Regular.woff') format('woff');
      font-weight: 400;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans SemiBold'), local('NotoSans-SemiBold'),
        url('${fontDirectory}/NotoSans-SemiBold.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-SemiBold.woff') format('woff');
      font-weight: 600;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans Bold'), local('NotoSans-Bold'), url('${fontDirectory}/NotoSans-Bold.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-Bold.woff') format('woff');
      font-weight: 700;
      font-style: normal;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans Light Italic'), local('NotoSans-LightItalic'),
        url('${fontDirectory}/NotoSans-LightItalic.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-LightItalic.woff') format('woff');
      font-weight: 300;
      font-style: italic;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans Italic'), local('NotoSans-Italic'),
        url('${fontDirectory}/NotoSans-Italic.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-Italic.woff') format('woff');
      font-weight: 400;
      font-style: italic;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans SemiBold Italic'), local('NotoSans-SemiBoldItalic'),
        url('${fontDirectory}/NotoSans-SemiBoldItalic.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-SemiBoldItalic.woff') format('woff');
      font-weight: 600;
      font-style: italic;
      font-display: swap;
    }

    @font-face {
      font-family: 'Noto Sans';
      src: local('Noto Sans Bold Italic'), local('NotoSans-BoldItalic'),
        url('${fontDirectory}/NotoSans-BoldItalic.woff2') format('woff2'),
        url('${fontDirectory}/NotoSans-BoldItalic.woff') format('woff');
      font-weight: 700;
      font-style: italic;
      font-display: swap;
    }
  `;
};
const fallbackFont = r$2 `sans-serif`;
const fontStyles = r$2 `
  :root {
    --zui-typography-body: var(--zui-body-font-style) var(--zui-body-font-weight) var(--zui-body-font-size) /
        var(--zui-body-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-body-text-transform: initial;

    --zui-typography-h0: var(--zui-h0-font-style) var(--zui-h0-font-weight) var(--zui-h0-font-size) /
        var(--zui-h0-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-h0-text-transform: initial;

    --zui-typography-h1: var(--zui-h1-font-style) var(--zui-h1-font-weight) var(--zui-h1-font-size) /
        var(--zui-h1-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-h1-text-transform: initial;

    --zui-typography-h2: var(--zui-h2-font-style) var(--zui-h2-font-weight) var(--zui-h2-font-size) /
        var(--zui-h2-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-h2-text-transform: initial;

    --zui-typography-h3: var(--zui-h3-font-style) var(--zui-h3-font-weight) var(--zui-h3-font-size) /
        var(--zui-h3-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-h3-text-transform: initial;

    --zui-typography-h4: var(--zui-h4-font-style) var(--zui-h4-font-weight) var(--zui-h4-font-size) /
        var(--zui-h4-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-h4-text-transform: initial;

    --zui-typography-subtitle1: var(--zui-subtitle1-font-style) var(--zui-subtitle1-font-weight)
        var(--zui-subtitle1-font-size) / var(--zui-subtitle1-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-subtitle1-text-transform: initial;

    --zui-typography-subtitle2: var(--zui-subtitle2-font-style) var(--zui-subtitle2-font-weight)
        var(--zui-subtitle2-font-size) / var(--zui-subtitle2-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-subtitle2-text-transform: initial;

    --zui-typography-caption: var(--zui-caption-font-style) var(--zui-caption-font-weight) var(--zui-caption-font-size) /
        var(--zui-caption-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-caption-text-transform: initial;

    --zui-typography-label1: var(--zui-label1-font-style) var(--zui-label1-font-weight) var(--zui-label1-font-size) /
        var(--zui-label1-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-label1-text-transform: initial;

    --zui-typography-label2: var(--zui-label2-font-style) var(--zui-label2-font-weight) var(--zui-label2-font-size) /
        var(--zui-label2-line-height) var(--zui-font-family),
      ${fallbackFont};

    --zui-typography-label2-text-transform: uppercase;
  }
`;
const segoeSettings = r$2 `
  :root {
    --zui-font-family: 'Segoe UI';

    --zui-h0-font-style: normal;
    --zui-h0-font-weight: 200;
    --zui-h0-font-size: 48px;
    --zui-h0-line-height: 1.5;

    --zui-h0-cap-margin-top: -0.3359em;
    --zui-h0-cap-margin-bottom: -0.4639em;

    --zui-h1-font-style: normal;
    --zui-h1-font-weight: 200;
    --zui-h1-font-size: 32px;
    --zui-h1-line-height: 1.5;

    --zui-h1-cap-margin-top: -0.3359em;
    --zui-h1-cap-margin-bottom: 0.4639em;

    --zui-h2-font-style: normal;
    --zui-h2-font-weight: 300;
    --zui-h2-font-size: 24px;
    --zui-h2-line-height: 1.5;

    --zui-h2-cap-margin-top: -0.3359em;
    --zui-h2-cap-margin-bottom: -0.4639em;

    --zui-h3-font-style: normal;
    --zui-h3-font-weight: 300;
    --zui-h3-font-size: 20px;
    --zui-h3-line-height: 1.4;

    --zui-h3-cap-margin-top: -0.2859em;
    --zui-h3-cap-margin-bottom: -0.4139em;

    --zui-h4-font-style: normal;
    --zui-h4-font-weight: 400;
    --zui-h4-font-size: 16px;
    --zui-h4-line-height: 1.5;

    --zui-h4-cap-margin-top: -0.3359em;
    --zui-h4-cap-margin-bottom: -0.4639em;

    --zui-subtitle1-font-style: normal;
    --zui-subtitle1-font-weight: 600;
    --zui-subtitle1-font-size: 14px;
    --zui-subtitle1-line-height: 1.42857143;

    --zui-subtitle1-cap-margin-top: -0.3002em;
    --zui-subtitle1-cap-margin-bottom: -0.4282em;

    --zui-subtitle2-font-style: normal;
    --zui-subtitle2-font-weight: 700;
    --zui-subtitle2-font-size: 12px;
    --zui-subtitle2-line-height: 1.33333333;

    --zui-subtitle2-cap-margin-top: -0.2526em;
    --zui-subtitle2-cap-margin-bottom: -0.3805em;

    --zui-body-font-style: normal;
    --zui-body-font-weight: 400;
    --zui-body-font-size: 14px;
    --zui-body-line-height: 1.42857143;

    --zui-body-cap-margin-top: -0.3002em;
    --zui-body-cap-margin-bottom: -0.4282em;

    --zui-caption-font-style: normal;
    --zui-caption-font-weight: 400;
    --zui-caption-font-size: 12px;
    --zui-caption-line-height: 1.33333333;

    --zui-caption-cap-margin-top: -0.2526em;
    --zui-caption-cap-margin-bottom: -0.3805em;

    --zui-label1-font-style: normal;
    --zui-label1-font-weight: 600;
    --zui-label1-font-size: 12px;
    --zui-label1-line-height: 1.33333333;

    --zui-label1-cap-margin-top: -0.2526em;
    --zui-label1-cap-margin-bottom: -0.3805em;

    --zui-label2-font-style: normal;
    --zui-label2-font-weight: 700;
    --zui-label2-font-size: 10px;
    --zui-label2-line-height: 1.2;

    --zui-label2-cap-margin-top: -0.1859em;
    --zui-label2-cap-margin-bottom: -0.3139em;
  }
`;
const notoLatinSettings = r$2 `
  :root {
    --zui-font-family: 'Noto Sans';

    --zui-h0-font-style: normal;
    --zui-h0-font-weight: 300;
    --zui-h0-font-size: 46px;
    --zui-h0-line-height: 1.56521739;

    --zui-h0-cap-margin-top: -0.3946em;
    --zui-h0-cap-margin-bottom: -0.4566em;

    --zui-h1-font-style: normal;
    --zui-h1-font-weight: 300;
    --zui-h1-font-size: 31px;
    --zui-h1-line-height: 1.5483871;

    --zui-h1-cap-margin-top: -0.3862em;
    --zui-h1-cap-margin-bottom: -0.4482em;

    --zui-h2-font-style: normal;
    --zui-h2-font-weight: 300;
    --zui-h2-font-size: 22px;
    --zui-h2-line-height: 1.63636364;

    --zui-h2-cap-margin-top: -0.4302em;
    --zui-h2-cap-margin-bottom: -0.4922em;

    --zui-h3-font-style: normal;
    --zui-h3-font-weight: 300;
    --zui-h3-font-size: 19px;
    --zui-h3-line-height: 1.47368421;

    --zui-h3-cap-margin-top: -0.3488em;
    --zui-h3-cap-margin-bottom: -0.4108em;

    --zui-h4-font-style: normal;
    --zui-h4-font-weight: 400;
    --zui-h4-font-size: 15px;
    --zui-h4-line-height: 1.6;

    --zui-h4-cap-margin-top: -0.412em;
    --zui-h4-cap-margin-bottom: -0.474em;

    --zui-subtitle1-font-style: normal;
    --zui-subtitle1-font-weight: 600;
    --zui-subtitle1-font-size: 13px;
    --zui-subtitle1-line-height: 1.53846154;

    --zui-subtitle1-cap-margin-top: -0.3812em;
    --zui-subtitle1-cap-margin-bottom: -0.4432em;

    --zui-subtitle2-font-style: normal;
    --zui-subtitle2-font-weight: 700;
    --zui-subtitle2-font-size: 11px;
    --zui-subtitle2-line-height: 1.45454545;

    --zui-subtitle2-cap-margin-top: -0.3393em;
    --zui-subtitle2-cap-margin-bottom: -0.4013em;

    --zui-body-font-style: normal;
    --zui-body-font-weight: 400;
    --zui-body-font-size: 13px;
    --zui-body-line-height: 1.53846154;

    --zui-body-cap-margin-top: -0.3812em;
    --zui-body-cap-margin-bottom: -0.4432em;

    --zui-caption-font-style: normal;
    --zui-caption-font-weight: 400;
    --zui-caption-font-size: 11px;
    --zui-caption-line-height: 1.45454545;

    --zui-caption-cap-margin-top: -0.3393em;
    --zui-caption-cap-margin-bottom: -0.4013em;

    --zui-label1-font-style: normal;
    --zui-label1-font-weight: 600;
    --zui-label1-font-size: 11px;
    --zui-label1-line-height: 1.45454545;

    --zui-label1-cap-margin-top: -0.3393em;
    --zui-label1-cap-margin-bottom: -0.4013em;

    --zui-label2-font-style: normal;
    --zui-label2-font-weight: 700;
    --zui-label2-font-size: 10px;
    --zui-label2-line-height: 1.2;

    --zui-label2-cap-margin-top: -0.212em;
    --zui-label2-cap-margin-bottom: -0.274em;
  }
`;
const notoCJKSettings = r$2 `
  :root {
    /* --zui-font-family would be set at typefaceManager */

    --zui-h0-font-style: normal;
    --zui-h0-font-weight: 300;
    --zui-h0-font-size: 46px;
    --zui-h0-line-height: 1.17391304;

    --zui-h1-font-style: normal;
    --zui-h1-font-weight: 300;
    --zui-h1-font-size: 36px;
    --zui-h1-line-height: 1.27777778;

    --zui-h2-font-style: normal;
    --zui-h2-font-weight: 300;
    --zui-h2-font-size: 28px;
    --zui-h2-line-height: 1.28571429;

    --zui-h3-font-style: normal;
    --zui-h3-font-weight: 300;
    --zui-h3-font-size: 21px;
    --zui-h3-line-height: 1.14285714;

    --zui-h4-font-style: normal;
    --zui-h4-font-weight: 300;
    --zui-h4-font-size: 18px;
    --zui-h4-line-height: 1.11111111;

    --zui-subtitle1-font-style: normal;
    --zui-subtitle1-font-weight: 700;
    --zui-subtitle1-font-size: 16px;
    --zui-subtitle1-line-height: 1.125;

    --zui-subtitle2-font-style: normal;
    --zui-subtitle2-font-weight: 700;
    --zui-subtitle2-font-size: 16px;
    --zui-subtitle2-line-height: 1;

    --zui-body-font-style: normal;
    --zui-body-font-weight: 400;
    --zui-body-font-size: 16px;
    --zui-body-line-height: 1;

    --zui-caption-font-style: normal;
    --zui-caption-font-weight: 400;
    --zui-caption-font-size: 14px;
    --zui-caption-line-height: 1;

    --zui-label1-font-style: normal;
    --zui-label1-font-weight: 700;
    --zui-label1-font-size: 15px;
    --zui-label1-line-height: 0.93333333;

    --zui-label2-font-style: normal;
    --zui-label2-font-weight: 700;
    --zui-label2-font-size: 15px;
    --zui-label2-line-height: 1.06666667;
  }
`;
var SelectableFonts;
(function (SelectableFonts) {
    SelectableFonts["Auto"] = "Auto";
    SelectableFonts["Segoe"] = "Segoe UI";
    SelectableFonts["Noto"] = "Noto Sans";
})(SelectableFonts || (SelectableFonts = {}));

// Noto Sans Japanese
// eslint-disable-next-line @typescript-eslint/naming-convention
const NotoSansJP = $ `<link
  href="https://fonts.googleapis.com/css?family=Noto+Sans+JP:300,400,700&display=swap&subset=japanese"
  rel="stylesheet"
/>`;
// Noto Sans Korean
// eslint-disable-next-line @typescript-eslint/naming-convention
const NotoSansKR = $ `<link
  href="https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,700&display=swap&subset=korean"
  rel="stylesheet"
/>`;
// Noto Sans Simplified Chinese
// eslint-disable-next-line @typescript-eslint/naming-convention
const NotoSansSC = $ `<link
  href="https://fonts.googleapis.com/css?family=Noto+Sans+SC:300,400,700&display=swap&subset=chinese-simplified"
  rel="stylesheet"
/>`;
// Noto Sans Traditional Chinese
// eslint-disable-next-line @typescript-eslint/naming-convention
const NotoSansTC = $ `<link
  href="https://fonts.googleapis.com/css?family=Noto+Sans+TC:300,400,700&display=swap&subset=chinese-traditional"
  rel="stylesheet"
/>`;
const asianLanguages = new Map([
    [
        'ja',
        {
            link: NotoSansJP,
            fontFamily: r$2 `Noto Sans JP`,
        },
    ],
    [
        'ko',
        {
            link: NotoSansKR,
            fontFamily: r$2 `Noto Sans KR`,
        },
    ],
    [
        'zh-Hans',
        {
            link: NotoSansSC,
            fontFamily: r$2 `Noto Sans SC`,
        },
    ],
    [
        'zh-Hant',
        {
            link: NotoSansTC,
            fontFamily: r$2 `Noto Sans TC`,
        },
    ],
]);
/**
 * Add google typefaces to application
 *
 * @param {TemplateResult} item Google font link
 * @returns {void}
 */
const registerGoogleFonts = (item) => {
    document.head.append(item.getTemplateElement().content);
};
/**
 * @param {string} font - the font that is to be registered
 */
const registerAsianFonts = (font) => {
    registerGoogleFonts(font.link);
    registerStyle(r$2 `
      :root {
        --zui-font-family: ${font.fontFamily};
      }
    `, 'font');
    registerStyle(notoCJKSettings, 'font');
};
const registerSegoe = () => {
    registerStyle(segoeUIFontFaces, 'font');
    registerStyle(segoeSettings, 'font');
};
const registerNoto = (fontDirectoryURL) => {
    registerStyle(fontFaces(fontDirectoryURL), 'font');
    registerStyle(notoLatinSettings, 'font');
};
/**
 * Add typefaces to application based on language and installed fonts
 *
 * @param {string} fontDirectoryURL - URL to downloaded fonts
 * @param {string} requestedFont - request a particular font
 * @returns {Promise} resolves with Promise<void> after font registration
 */
const registerTypefaces = (fontDirectoryURL, requestedFont) => {
    document.head.querySelectorAll('[data-style-group=font]').forEach((style) => style.remove());
    return (Promise.resolve()
        .then(() => registerStyle(fontStyles, 'font'))
        // Get browser language
        .then(() => asianLanguages.get(document.documentElement.lang))
        // Try to find browser language in map of asian Languages
        .then((asianFont) => (asianFont ? asianFont : Promise.reject(new Error())))
        .then(registerAsianFonts)
        .catch(() => {
        switch (requestedFont) {
            case SelectableFonts.Segoe:
                registerSegoe();
                break;
            case SelectableFonts.Noto:
                registerNoto(fontDirectoryURL);
                break;
            case SelectableFonts.Auto:
            default:
                return loadAvailableFont(fontDirectoryURL);
        }
    }));
};
const loadAvailableFont = (fontDirectoryURL) => {
    // Creates a Segoe UI font-face definition with local font
    const segoeUICheckFontFace = new FontFace('Segoe UI', "local('Segoe UI')");
    return (segoeUICheckFontFace
        // Checks if Segoe UI can be loaded from local
        .load()
        .then(() => {
        registerSegoe();
    })
        .catch(() => {
        registerNoto(fontDirectoryURL);
    }));
};

export { SelectableFonts, fontStyles, registerStyle, registerTheme, registerTypefaces, setAppTheme, themeBaseLegacy as themeBase, themeBaseLegacy, themeBaseLegacyRaw, themeDark, themeLight, themeTranslucent, themeZbdsBase, themeZbdsBaseRaw, themeZbdsDark, themeZbdsLight, themeZbdsTranslucent };
